import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../pages/AuthContext';
import "../styles/RootUsers.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faUsers, faUserPlus, faEdit, faTrash, faSearch, faInfoCircle, faFilter,
    faSync, faDownload, faEye, faUser, faPlus, faEnvelope, faPhone,
    faBuilding, faMapMarkerAlt, faPalette, faLanguage, faImage, faLock,
    faCheckCircle, faTimesCircle, faCalendarAlt, faChartBar, faSignInAlt,
    faSave, faTimes, faSpinner, faExclamationTriangle, faCog, faShieldAlt,
    faToggleOn, faToggleOff, faChevronLeft, faChevronRight, faBusinessTime, faSitemap, faUserTag, faStore,
    faShop, faCheckSquare, faSquare, faCircle, faDotCircle, faList,
    faChevronDown, faChevronUp, faCheckDouble, faLayerGroup, faBarcode,
    faCreditCard, faMoneyBill, faUniversity, faReceipt, faHistory,
    faIdCard, faClock, faHourglassHalf, faBan, faExchangeAlt, faFileAlt,
    faTag, faShoppingCart, faBox, faWallet, faCalculator, faPercent,
    faAddressCard, faKey, faUnlock, faEye as faEyeOpen, faEyeSlash,
    faGlobe, faFlag, faMoon, faSun, faLaptopCode, faMobileAlt, faTabletAlt, faLaptop,
    faCalendar, faFilePdf, faFileExcel, faPrint, faUndo, faNetworkWired,
    faShare, faLink, faCopy, faCrown, faCreditCard as faCreditCardIcon,
    faCalendarPlus, faMoneyBillWave, faClock as faClockIcon, faArrowRight,
    faArrowLeft, faInfo, faWarning, faCheck, faXmark, faCircleCheck,
    faCircleXmark, faCircleInfo, faTriangleExclamation
} from '@fortawesome/free-solid-svg-icons';

// ==============================================
// Translation Utility
// ==============================================
const createRootUsersTranslator = () => {
    let cache = new Map();
    let translationListeners = new Set();

    const loadFromCache = () => {
        try {
            const cached = localStorage.getItem('ourzest_root_users_translations');
            if (cached) {
                const parsed = JSON.parse(cached);
                Object.entries(parsed).forEach(([key, value]) => {
                    cache.set(key, value);
                });
            }
        } catch (e) {
            console.log("No cache found in Root Users");
        }
    };

    const saveToCache = () => {
        try {
            const cacheObj = {};
            cache.forEach((value, key) => {
                cacheObj[key] = value;
            });
            localStorage.setItem('ourzest_root_users_translations', JSON.stringify(cacheObj));
        } catch (e) {
            console.error("Error saving to cache:", e);
        }
    };

    const translateAPI = async (text, targetLang) => {
        if (targetLang === 'en') return text;

        const dict = {
            'ur': {
                'Root Users Management': 'روٹ صارفین کا انتظام',
                'Manage all system users and their permissions': 'تمام سسٹم صارفین اور ان کی اجازتوں کا انتظام کریں',
                'Add New User': 'نیا صارف شامل کریں',
                'Edit User': 'صارف میں ترمیم کریں',
                'Confirm Delete': 'حذف کرنے کی تصدیق',
                'ID': 'شناخت نمبر',
                'User': 'صارف',
                'Name': 'نام',
                'Phone': 'فون',
                'Business': 'کاروبار',
                'Status': 'حالت',
                'Subscription': 'سبسکرپشن',
                'Primary Role': 'بنیادی کردار',
                'Shop Roles': 'دکان کے کردار',
                'Last Login': 'آخری لاگ ان',
                'Actions': 'اعمال',
                'Username': 'صارف نام',
                'Email': 'ای میل',
                'Password': 'پاس ورڈ',
                'Confirm Password': 'پاس ورڈ کی تصدیق',
                'Full Name': 'مکمل نام',
                'Phone Number': 'فون نمبر',
                'Business Name': 'کاروبار کا نام',
                'Business Module': 'کاروباری ماڈیول',
                'Business Address': 'کاروباری پتہ',
                'Theme Color': 'تھیم کا رنگ',
                'Language': 'زبان',
                'Profile Image': 'پروفائل تصویر',
                'Business Logo': 'کاروباری لوگو',
                'Assign Shop Roles': 'دکان کے کردار تفویض کریں',
                'Shop': 'دکان',
                'Role': 'کردار',
                'Add Another Shop': 'ایک اور دکان شامل کریں',
                'Active': 'فعال',
                'Inactive': 'غیر فعال',
                'Suspended': 'معطل',
                'Save': 'محفوظ کریں',
                'Update': 'اپ ڈیٹ کریں',
                'Cancel': 'منسوخ کریں',
                'Delete': 'حذف کریں',
                'Refresh': 'ریفریش کریں',
                'Clear': 'صاف کریں',
                'Saving...': 'محفوظ ہو رہا ہے...',
                'Updating...': 'اپ ڈیٹ ہو رہا ہے...',
                'Loading...': 'لوڈ ہو رہا ہے...',
                'Please wait while we load user data': 'براہ کرم انتظار کریں جب تک ہم صارف کا ڈیٹا لوڈ کرتے ہیں',
                'No users found': 'کوئی صارف نہیں ملا',
                'User created successfully!': 'صارف کامیابی سے تخلیق ہو گیا!',
                'User updated successfully!': 'صارف کامیابی سے اپ ڈیٹ ہو گیا!',
                'User deleted successfully!': 'صارف کامیابی سے حذف ہو گیا!',
                'Search users...': 'صارفین تلاش کریں...',
                'Filter by Status': 'حالت کے مطابق فلٹر کریں',
                'All Status': 'تمام حالتیں',
                'No shop roles assigned': 'کوئی دکان کے کردار تفویض نہیں',
                'more': 'مزید',
                'Select Role': 'کردار منتخب کریں',
                'Success': 'کامیابی',
                'Error': 'خرابی',
                'Warning': 'انتباہ',
                'Page': 'صفحہ',
                'of': 'از',
                'Dark Mode': 'ڈارک موڈ',
                'Light Mode': 'لائٹ موڈ',
                'Login History': 'لاگ ان ہسٹری',
                'View History': 'ہسٹری دیکھیں',
                'IP Address': 'آئی پی ایڈریس',
                'Device': 'ڈیوائس',
                'Browser': 'براؤزر',
                'OS': 'آپریٹنگ سسٹم',
                'Duration': 'دورانیہ',
                'Date & Time': 'تاریخ اور وقت',
                'Back to Users': 'صارفین پر واپس جائیں',
                'Users': 'صارفین',
                'Total Records': 'کل ریکارڈز',
                'Successful Logins': 'کامیاب لاگ ان',
                'Failed Attempts': 'ناکام کوششیں',
                'Unique Users': 'منفرد صارفین',
                'Clear Filters': 'فلٹرز صاف کریں',
                'Export CSV': 'CSV ایکسپورٹ کریں',
                'Export PDF': 'PDF ایکسپورٹ کریں',
                'Date From': 'تاریخ سے',
                'Date To': 'تاریخ تک',
                'All Devices': 'تمام آلات',
                'All Browsers': 'تمام براؤزرز',
                'All OS': 'تمام آپریٹنگ سسٹمز',
                'Change Password': 'پاس ورڈ تبدیل کریں',
                'New Password': 'نیا پاس ورڈ',
                'Update Password': 'پاس ورڈ اپ ڈیٹ کریں',
                'Password updated successfully!': 'پاس ورڈ کامیابی سے اپ ڈیٹ ہو گیا!',
                'Inherited': 'وراثت میں ملا',
                'Inherited from': 'سے وراثت میں ملا',
                'Admin Subscription': 'ایڈمن سبسکرپشن',
                'No Subscription': 'کوئی سبسکرپشن نہیں',
                'Expired': 'میعاد ختم',
                'Expiring Soon': 'جلد میعاد ختم',
                'Active Subscription': 'فعال سبسکرپشن',
                'Admin': 'ایڈمن',
                'User under admin': 'ایڈمن کے تحت صارف',
                'Subscription Details': 'سبسکرپشن کی تفصیلات',
                'Application': 'ایپلیکیشن',
                'Plan Type': 'پلان کی قسم',
                'Amount': 'رقم',
                'Start Date': 'شروع کرنے کی تاریخ',
                'Expiry Date': 'میعاد ختم ہونے کی تاریخ',
                'Monthly': 'ماہانہ',
                'Yearly': 'سالانہ',
                'Custom': 'اپنی مرضی',
                'Renew': 'تجدید کریں',
                'Cancel Subscription': 'سبسکرپشن منسوخ کریں',
                'Payment Status': 'ادائیگی کی حالت',
                'Paid': 'ادا شدہ',
                'Unpaid': 'غیر ادا شدہ',
                'Partially Paid': 'جزوی طور پر ادا شدہ',
                'Overdue': 'زائد المیعاد',
                'Grace Period': 'رحمت کی مدت',
                'Suspended': 'معطل',
                'Auto Renew': 'خودکار تجدید',
                'Total Customers': 'کل صارفین',
                'Active Subscriptions': 'فعال سبسکرپشنز',
                'Expiring This Month': 'اس مہینے میعاد ختم',
                'Expired Accounts': 'میعاد ختم اکاؤنٹس',
                'Outstanding Dues': 'بقایا جات',
                'Revenue This Month': 'اس مہینے کی آمدنی',
                'Revenue This Year': 'اس سال کی آمدنی'
            },
            'ar': {
                'Root Users Management': 'إدارة المستخدمين الجذر',
                'Manage all system users and their permissions': 'إدارة جميع مستخدمي النظام وأذوناتهم',
                'Add New User': 'إضافة مستخدم جديد',
                'Edit User': 'تحرير المستخدم',
                'Confirm Delete': 'تأكيد الحذف',
                'ID': 'الرقم',
                'User': 'المستخدم',
                'Name': 'الاسم',
                'Phone': 'الهاتف',
                'Business': 'العمل',
                'Status': 'الحالة',
                'Subscription': 'الاشتراك',
                'Primary Role': 'الدور الأساسي',
                'Shop Roles': 'أدوار المتجر',
                'Last Login': 'آخر تسجيل دخول',
                'Actions': 'الإجراءات',
                'Username': 'اسم المستخدم',
                'Email': 'البريد الإلكتروني',
                'Password': 'كلمة المرور',
                'Confirm Password': 'تأكيد كلمة المرور',
                'Full Name': 'الاسم الكامل',
                'Phone Number': 'رقم الهاتف',
                'Business Name': 'اسم العمل',
                'Business Module': 'وحدة العمل',
                'Business Address': 'عنوان العمل',
                'Theme Color': 'لون السمة',
                'Language': 'اللغة',
                'Profile Image': 'صورة الملف الشخصي',
                'Business Logo': 'شعار العمل',
                'Assign Shop Roles': 'تعيين أدوار المتجر',
                'Shop': 'المتجر',
                'Role': 'الدور',
                'Add Another Shop': 'إضافة متجر آخر',
                'Active': 'نشط',
                'Inactive': 'غير نشط',
                'Suspended': 'معلق',
                'Save': 'حفظ',
                'Update': 'تحديث',
                'Cancel': 'إلغاء',
                'Delete': 'حذف',
                'Refresh': 'تحديث',
                'Clear': 'مسح',
                'Saving...': 'جاري الحفظ...',
                'Updating...': 'جاري التحديث...',
                'Loading...': 'جاري التحميل...',
                'Please wait while we load user data': 'يرجى الانتظار أثناء تحميل بيانات المستخدم',
                'No users found': 'لم يتم العثور على مستخدمين',
                'User created successfully!': 'تم إنشاء المستخدم بنجاح!',
                'User updated successfully!': 'تم تحديث المستخدم بنجاح!',
                'User deleted successfully!': 'تم حذف المستخدم بنجاح!',
                'Search users...': 'بحث عن المستخدمين...',
                'Filter by Status': 'تصفية حسب الحالة',
                'All Status': 'جميع الحالات',
                'No shop roles assigned': 'لم يتم تعيين أدوار المتجر',
                'more': 'المزيد',
                'Select Role': 'اختر الدور',
                'Success': 'نجاح',
                'Error': 'خطأ',
                'Warning': 'تحذير',
                'Page': 'صفحة',
                'of': 'من',
                'Dark Mode': 'الوضع الداكن',
                'Light Mode': 'الوضع الفاتح',
                'Login History': 'سجل الدخول',
                'View History': 'عرض السجل',
                'IP Address': 'عنوان IP',
                'Device': 'الجهاز',
                'Browser': 'المتصفح',
                'OS': 'نظام التشغيل',
                'Duration': 'المدة',
                'Date & Time': 'التاريخ والوقت',
                'Back to Users': 'العودة إلى المستخدمين',
                'Users': 'المستخدمين',
                'Total Records': 'إجمالي السجلات',
                'Successful Logins': 'تسجيلات الدخول الناجحة',
                'Failed Attempts': 'المحاولات الفاشلة',
                'Unique Users': 'المستخدمين الفريدين',
                'Clear Filters': 'مسح الفلاتر',
                'Export CSV': 'تصدير CSV',
                'Export PDF': 'تصدير PDF',
                'Date From': 'تاريخ من',
                'Date To': 'تاريخ إلى',
                'All Devices': 'جميع الأجهزة',
                'All Browsers': 'جميع المتصفحات',
                'All OS': 'جميع أنظمة التشغيل',
                'Change Password': 'تغيير كلمة المرور',
                'New Password': 'كلمة المرور الجديدة',
                'Update Password': 'تحديث كلمة المرور',
                'Password updated successfully!': 'تم تحديث كلمة المرور بنجاح!',
                'Inherited': 'موروث',
                'Inherited from': 'موروث من',
                'Admin Subscription': 'اشتراك المشرف',
                'No Subscription': 'لا يوجد اشتراك',
                'Expired': 'منتهي',
                'Expiring Soon': 'ينتهي قريباً',
                'Active Subscription': 'اشتراك نشط',
                'Admin': 'مشرف',
                'User under admin': 'مستخدم تحت المشرف',
                'Subscription Details': 'تفاصيل الاشتراك',
                'Application': 'التطبيق',
                'Plan Type': 'نوع الخطة',
                'Amount': 'المبلغ',
                'Start Date': 'تاريخ البدء',
                'Expiry Date': 'تاريخ الانتهاء',
                'Monthly': 'شهري',
                'Yearly': 'سنوي',
                'Custom': 'مخصص',
                'Renew': 'تجديد',
                'Cancel Subscription': 'إلغاء الاشتراك',
                'Payment Status': 'حالة الدفع',
                'Paid': 'مدفوع',
                'Unpaid': 'غير مدفوع',
                'Partially Paid': 'مدفوع جزئياً',
                'Overdue': 'متأخر',
                'Grace Period': 'فترة سماح',
                'Suspended': 'معلق',
                'Auto Renew': 'تجديد تلقائي',
                'Total Customers': 'إجمالي العملاء',
                'Active Subscriptions': 'الاشتراكات النشطة',
                'Expiring This Month': 'ينتهي هذا الشهر',
                'Expired Accounts': 'حسابات منتهية',
                'Outstanding Dues': 'المستحقات المعلقة',
                'Revenue This Month': 'الإيرادات هذا الشهر',
                'Revenue This Year': 'الإيرادات هذا العام'
            }
        };

        if (dict[targetLang] && dict[targetLang][text]) {
            return dict[targetLang][text];
        }

        try {
            const response = await fetch('https://translate.argosopentech.com/translate', {
                method: 'POST',
                body: JSON.stringify({ q: text, source: 'en', target: targetLang }),
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.ok) {
                const data = await response.json();
                return data.translatedText;
            }
        } catch (e) {
            console.log("LibreTranslate failed");
        }
        return text;
    };

    const translateText = async (text, targetLang) => {
        const cacheKey = `${text}_${targetLang}`;
        if (cache.has(cacheKey)) {
            return cache.get(cacheKey);
        }
        const translated = await translateAPI(text, targetLang);
        cache.set(cacheKey, translated);
        saveToCache();
        return translated;
    };

    const defaultTexts = {
        rootUsers: 'Root Users Management',
        manageUsers: 'Manage all system users and their permissions',
        addNewUser: 'Add New User',
        editUser: 'Edit User',
        confirmDelete: 'Confirm Delete',
        id: 'ID',
        user: 'User',
        name: 'Name',
        phone: 'Phone',
        business: 'Business',
        status: 'Status',
        subscription: 'Subscription',
        subscriptionDetails: 'Subscription Details',
        primaryRole: 'Primary Role',
        shopRoles: 'Shop Roles',
        lastLogin: 'Last Login',
        actions: 'Actions',
        username: 'Username',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        fullName: 'Full Name',
        phoneNumber: 'Phone Number',
        businessName: 'Business Name',
        businessModule: 'Business Module',
        businessAddress: 'Business Address',
        themeColor: 'Theme Color',
        language: 'Language',
        profileImage: 'Profile Image',
        businessLogo: 'Business Logo',
        assignShopRoles: 'Assign Shop Roles',
        shop: 'Shop',
        role: 'Role',
        addAnotherShop: 'Add Another Shop',
        active: 'Active',
        inactive: 'Inactive',
        suspended: 'Suspended',
        dashboard: 'Dashboard',
        retail: 'Retail',
        restaurant: 'Restaurant',
        inventory: 'Inventory',
        english: 'English',
        urdu: 'Urdu',
        arabic: 'Arabic',
        save: 'Save',
        update: 'Update',
        cancel: 'Cancel',
        delete: 'Delete',
        refresh: 'Refresh',
        clear: 'Clear',
        saving: 'Saving...',
        updating: 'Updating...',
        loading: 'Loading...',
        loadingData: 'Please wait while we load user data',
        noUsersFound: 'No users found',
        userCreated: 'User created successfully!',
        userUpdated: 'User updated successfully!',
        userDeleted: 'User deleted successfully!',
        usernameRequired: 'Username is required',
        emailRequired: 'Email is required',
        invalidEmail: 'Invalid email address',
        passwordRequired: 'Password is required',
        passwordMinLength: 'Password must be at least 5 characters',
        passwordsDoNotMatch: 'Passwords do not match',
        fullNameRequired: 'Full name is required',
        atLeastOneShop: 'At least one shop with role must be assigned',
        shopRequired: 'Shop is required',
        roleRequired: 'Role is required',
        deleteConfirmMessage: 'Are you sure you want to delete this user?',
        deleteWarning: 'This action cannot be undone.',
        userInformation: 'User Information',
        businessInformation: 'Business Information',
        securitySettings: 'Security Settings',
        searchPlaceholder: 'Search users...',
        filterByStatus: 'Filter by Status',
        allStatus: 'All Status',
        noShopRoles: 'No shop roles assigned',
        more: 'more',
        selectRole: 'Select Role',
        noRolesAvailable: 'No roles available for this shop',
        firstShopDefault: 'First shop will be set as default',
        userRolesOnly: 'You can assign user roles only (manager_*, user_*, etc.)',
        enableTwoFactor: 'Enable Two-Factor Authentication',
        allowCreateShops: 'Allow to create shops',
        page: 'Page',
        of: 'of',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        noShopsAvailable: 'No shops available to assign',
        allShopsAssigned: 'All available shops are already assigned',
        atLeastOneShopRequired: 'User must have at least one shop assignment',
        shopRoleRequired: 'Each shop must have a role selected',
        deleting: 'Deleting...',
        darkMode: 'Dark Mode',
        lightMode: 'Light Mode',
        loginHistory: 'Login History',
        viewHistory: 'View History',
        ipAddress: 'IP Address',
        device: 'Device',
        browser: 'Browser',
        os: 'OS',
        duration: 'Duration',
        dateTime: 'Date & Time',
        close: 'Close',
        backToUsers: 'Back to Users',
        users: 'Users',
        totalRecords: 'Total Records',
        successfulLogins: 'Successful Logins',
        failedAttempts: 'Failed Attempts',
        uniqueUsers: 'Unique Users',
        clearFilters: 'Clear Filters',
        exportCSV: 'Export CSV',
        exportPDF: 'Export PDF',
        dateFrom: 'Date From',
        dateTo: 'Date To',
        allDevices: 'All Devices',
        allBrowsers: 'All Browsers',
        allOS: 'All OS',
        changePassword: 'Change Password',
        newPassword: 'New Password',
        updatePassword: 'Update Password',
        passwordUpdated: 'Password updated successfully!',
        inherited: 'Inherited',
        inheritedFrom: 'Inherited from',
        adminSubscription: 'Admin Subscription',
        noSubscription: 'No Subscription',
        expired: 'Expired',
        expiringSoon: 'Expiring Soon',
        activeSubscription: 'Active Subscription',
        admin: 'Admin',
        userUnderAdmin: 'User under admin',
        application: 'Application',
        planType: 'Plan Type',
        amount: 'Amount',
        startDate: 'Start Date',
        expiryDate: 'Expiry Date',
        monthly: 'Monthly',
        yearly: 'Yearly',
        custom: 'Custom',
        renew: 'Renew',
        cancelSubscription: 'Cancel Subscription',
        paymentStatus: 'Payment Status',
        paid: 'Paid',
        unpaid: 'Unpaid',
        partiallyPaid: 'Partially Paid',
        overdue: 'Overdue',
        gracePeriod: 'Grace Period',
        autoRenew: 'Auto Renew',
        totalCustomers: 'Total Customers',
        activeSubscriptions: 'Active Subscriptions',
        expiringThisMonth: 'Expiring This Month',
        expiredAccounts: 'Expired Accounts',
        outstandingDues: 'Outstanding Dues',
        revenueThisMonth: 'Revenue This Month',
        revenueThisYear: 'Revenue This Year'
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        const translations = {};
        const promises = [];
        Object.keys(defaultTexts).forEach(key => {
            const cacheKey = `${defaultTexts[key]}_${lang}`;
            if (cache.has(cacheKey)) {
                translations[key] = cache.get(cacheKey);
            } else {
                promises.push(translateText(defaultTexts[key], lang).then(translated => {
                    translations[key] = translated;
                }));
            }
        });
        if (promises.length > 0) {
            await Promise.all(promises);
            saveToCache();
        }
        return translations;
    };

    const addListener = (callback) => {
        translationListeners.add(callback);
    };

    const removeListener = (callback) => {
        translationListeners.delete(callback);
    };

    loadFromCache();

    return {
        getTranslations,
        translateText,
        addListener,
        removeListener
    };
};

const rootUsersTranslator = createRootUsersTranslator();

// ==============================================
// Toast Notification Component
// ==============================================
const ToastNotification = ({ toast, setToast, translations, darkMode }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success': return faCheckCircle;
            case 'error': return faExclamationTriangle;
            case 'warning': return faExclamationTriangle;
            default: return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success': return translations?.success || 'Success';
            case 'error': return translations?.error || 'Error';
            case 'warning': return translations?.warning || 'Warning';
            default: return '';
        }
    };

    if (!toast.show) return null;

    const isRTL = document.documentElement.dir === 'rtl';

    return (
        <div className={`root-users-toast root-users-toast-${toast.type} ${isRTL ? 'root-users-toast-rtl' : ''}`}>
            <div className="root-users-toast-content">
                <div className="root-users-toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="root-users-toast-message">
                    <div className="root-users-toast-title">{getTitleForType(toast.type)}</div>
                    <div>{toast.message}</div>
                </div>
                <button className="root-users-toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
            <div className="root-users-toast-timer">
                <div className="root-users-toast-progress" style={{ width: `${toast.progress}%` }}></div>
            </div>
        </div>
    );
};

// ==============================================
// Helper Functions
// ==============================================
const str_starts_with = (str, prefix) => {
    return str ? str.startsWith(prefix) : false;
};

const str_ends_with = (str, suffix) => {
    return str ? str.endsWith(suffix) : false;
};

const getRoleCategory = (role) => {
    if (!role) return '';
    if (str_starts_with(role, 'admin_')) {
        return role.replace('admin_', '');
    }
    return '';
};

// ==============================================
// Main RootUsers Component
// ==============================================
const RootUsers = () => {
    const { user } = useAuth();

    // State
    const [users, setUsers] = useState([]);
    const [businessNames, setBusinessNames] = useState([]);
    const [shops, setShops] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalType, setModalType] = useState('add');
    const [selectedUser, setSelectedUser] = useState(null);
    const [availableShopsForAssignment, setAvailableShopsForAssignment] = useState([]);
    const [shopRolesData, setShopRolesData] = useState([]);
    const [adminAvailableShops, setAdminAvailableShops] = useState([]);
    const [allAdminRoles, setAllAdminRoles] = useState([]);
    const [allUserRoles, setAllUserRoles] = useState([]);

    // Complete Subscription State
    const [applications, setApplications] = useState([]);
    const [subscriptionData, setSubscriptionData] = useState({
        application_id: '',
        plan_type: 'monthly',
        amount: 0,
        start_date: new Date().toISOString().split('T')[0],
        add_subscription: false,
        auto_renew: true,
        grace_period_days: 7
    });
    const [showSubscriptionSection, setShowSubscriptionSection] = useState(false);
    const [selectedUserSubscriptions, setSelectedUserSubscriptions] = useState([]);
    const [subscriptionLoading, setSubscriptionLoading] = useState(false);
    const [renewingSubscription, setRenewingSubscription] = useState(null);

    // Subscription Stats State
    const [subscriptionStats, setSubscriptionStats] = useState({
        total_customers: 0,
        active_subscriptions: 0,
        expiring_this_month: 0,
        expired_accounts: 0,
        outstanding_dues: 0,
        revenue_this_month: 0,
        revenue_this_year: 0,
        by_plan_type: [],
        by_status: [],
        by_payment_status: [],
        by_application: [],
        customers_with_active: 0,
        customers_without_active: 0
    });
    const [showSubscriptionStats, setShowSubscriptionStats] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);

    // Password update state
    const [passwordModalOpen, setPasswordModalOpen] = useState(false);
    const [passwordFormData, setPasswordFormData] = useState({
        userId: null,
        newPassword: '',
        confirmPassword: '',
    });
    const [passwordErrors, setPasswordErrors] = useState({});
    const [updatingPassword, setUpdatingPassword] = useState(false);

    // Shop search dropdown state
    const [allAvailableShops, setAllAvailableShops] = useState([]);
    const [shopSearchTerm, setShopSearchTerm] = useState('');
    const [showShopDropdown, setShowShopDropdown] = useState(false);
    const [shopDropdownRef, setShopDropdownRef] = useState(null);

    // Login History View State
    const [showHistoryView, setShowHistoryView] = useState(false);
    const [allLoginHistory, setAllLoginHistory] = useState([]);
    const [filteredHistory, setFilteredHistory] = useState([]);
    const [loadingAllHistory, setLoadingAllHistory] = useState(false);
    const [historyFilters, setHistoryFilters] = useState({
        search: '',
        dateFrom: '',
        dateTo: '',
        deviceType: '',
        browser: '',
        os: '',
        status: '',
        ipAddress: ''
    });
    const [historyPagination, setHistoryPagination] = useState({
        page: 1,
        limit: 20,
        total: 0,
        pages: 1
    });
    const [exporting, setExporting] = useState(false);

    // Dark Mode State
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });

    // Language and Translation
    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return localStorage.getItem('ourzest_language') || 'en';
    });
    const [translations, setTranslations] = useState({});
    const [isTranslating, setIsTranslating] = useState(false);

    // Toast state
    const [toast, setToast] = useState({
        show: false,
        type: '',
        message: '',
        direction: 'ltr',
        progress: 100,
        timeLeft: 3
    });

    // Form data
    const [formData, setFormData] = useState({
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        fullname: '',
        phonenumber: '',
        businessname: '',
        businessmodule: 'dashboard',
        businessaddress: '',
        themecolor: '#4F46E5',
        language: 'english',
        status: 'active',
        two_factor_enabled: 0,
        can_create_shops: 0,
        shop_id: '',
        shops: '[]',
        default_shop_id: '',
        profile_image: null,
        bussinesslogo: null
    });

    const [errors, setErrors] = useState({});
    const [filters, setFilters] = useState({
        search: '',
        status: '',
        role: '',
        businessmodule: '',
        businessname: '',
        shop_id: ''
    });
    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total: 0,
        pages: 1
    });

    // Refs
    const fileInputRef = useRef(null);
    const logoInputRef = useRef(null);
    const toastTimerRef = useRef(null);

    // Theme color
    const [themeColor, setThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#4F46E5';
    });

    // Device type options for filter
    const deviceTypes = ['desktop', 'mobile', 'tablet'];
    const statusOptions = ['success', 'failed'];

    // Check if current user is superadmin
    const isSuperAdmin = user?.role === 'super_admin';

    // Check if current user is an admin (not superadmin)
    const isAdmin = user?.role?.startsWith('admin_') && user?.role !== 'super_admin';

    // Get unique browsers from history
    const getUniqueBrowsers = () => {
        const browsers = new Set();
        allLoginHistory.forEach(record => {
            if (record.browser_name && record.browser_name !== 'Unknown') {
                browsers.add(record.browser_name);
            }
        });
        return Array.from(browsers).sort();
    };

    // Get unique OS from history
    const getUniqueOS = () => {
        const osList = new Set();
        allLoginHistory.forEach(record => {
            if (record.os_name && record.os_name !== 'Unknown') {
                osList.add(record.os_name);
            }
        });
        return Array.from(osList).sort();
    };

    // ==============================================
    // TOAST FUNCTIONS (Defined early)
    // ==============================================
    const showToast = useCallback((type, message) => {
        if (toastTimerRef.current) clearInterval(toastTimerRef.current);

        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const direction = isRTL ? 'rtl' : 'ltr';

        setToast({ show: true, type, message, direction, progress: 100, timeLeft: 3 });

        let timeLeft = 3;
        const timer = setInterval(() => {
            timeLeft -= 0.1;
            const progress = (timeLeft / 3) * 100;
            setToast(prev => ({ ...prev, progress, timeLeft: parseFloat(timeLeft.toFixed(1)) }));
            if (timeLeft <= 0) {
                clearInterval(timer);
                setToast(prev => ({ ...prev, show: false }));
            }
        }, 100);

        toastTimerRef.current = timer;
    }, [currentLanguage]);

    // ==============================================
    // DATA LOADING FUNCTIONS
    // ==============================================
    const loadUsers = useCallback(async () => {
        setLoading(true);
        try {
            const params = new URLSearchParams({
                action: 'list',
                page: pagination.page,
                limit: pagination.limit,
                ...(filters.search && { search: filters.search }),
                ...(filters.status && { status: filters.status }),
                ...(filters.role && { role: filters.role }),
                ...(filters.businessmodule && { businessmodule: filters.businessmodule }),
                ...(filters.businessname && { businessname: filters.businessname }),
                ...(filters.shop_id && { shop_id: filters.shop_id }),
                current_user_id: user?.id || '',
                current_user_role: user?.role || ''
            });
            const response = await fetch(`https://ourzestapp.online/oz_backend/root_users.php?${params}`);
            const data = await response.json();
            if (data.success) {
                setUsers(data.data || []);
                setBusinessNames(data.business_names || []);
                setPagination(data.pagination || pagination);
            } else {
                throw new Error(data.error || 'Failed to load users');
            }
        } catch (error) {
            showToast('error', error.message);
        } finally {
            setLoading(false);
        }
    }, [pagination.page, pagination.limit, filters, user?.id, user?.role, showToast]);

    const loadAllShops = useCallback(async () => {
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/shops.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_shops' })
            });
            const data = await response.json();
            if (data.status === 'success') setShops(data.data || []);
        } catch (error) {
            console.error('Error loading shops:', error);
        }
    }, []);

    const loadAllRoles = useCallback(async () => {
        try {
            const adminResponse = await fetch(`https://ourzestapp.online/oz_backend/root_users.php?action=get_shop_roles`);
            const adminData = await adminResponse.json();
            if (adminData.success) {
                setAllAdminRoles(adminData.roles || []);
            } else {
                setAllAdminRoles([
                    { value: 'admin_pos', label: 'Admin POS' },
                    { value: 'admin_fabrics', label: 'Admin Fabrics' },
                    // { value: 'admin_mechanicsth', label: 'Admin Mechanics Th' },
                    // { value: 'admin_mechanicsap', label: 'Admin Mechanics Ap' },
                    { value: 'admin_hardwareth', label: 'Admin Hardware Th' },
                    // { value: 'admin_hardwareap', label: 'Admin Hardware Ap' },
                    // { value: 'admin_autosth', label: 'Admin Autos Th' },
                    { value: 'admin_autosap', label: 'Admin Autos Ap' },
                    { value: 'admin_pharmacy', label: 'Admin Pharmacy' },
                    { value: 'admin_pharmacytax', label: 'Admin Pharmacy (Tax)' },
                    { value: 'admin_cosmetics', label: 'Admin Cosmetics' },
                    
                    { value: 'admin_solar', label: 'Admin Solar' },
                    { value: 'admin_electronics', label: 'Admin Electronics' },
                ]);
            }
            await loadUserRolesForCurrentAdmin();
        } catch (error) {
            console.error('Error loading roles:', error);
            setAllAdminRoles([
                { value: 'admin_pos', label: 'Admin POS' },
                { value: 'admin_fabrics', label: 'Admin Fabrics' },
                // { value: 'admin_mechanicsth', label: 'Admin Mechanics Th' },
                // { value: 'admin_mechanicsap', label: 'Admin Mechanics Ap' },
                { value: 'admin_hardwareth', label: 'Admin Hardware Th' },
                // { value: 'admin_hardwareap', label: 'Admin Hardware Ap' },
                // { value: 'admin_autosth', label: 'Admin Autos Th' },
                { value: 'admin_autosap', label: 'Admin Autos Ap' },
                { value: 'admin_pharmacy', label: 'Admin Pharmacy' },
                { value: 'admin_pharmacytax', label: 'Admin Pharmacy (Tax)' },
                { value: 'admin_cosmetics', label: 'Admin Cosmetics' },
                
                { value: 'admin_solar', label: 'Admin Solar' },
                { value: 'admin_elecctronics', label: 'Admin Electronics' },
            ]);
        }
    }, []);

    const loadUserRolesForCurrentAdmin = useCallback(async () => {
        if (!user?.role) return;
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ action: 'get_user_shop_roles', user_id: user.id })
            });
            const data = await response.json();
            let adminCategories = [];
            if (data.success && data.data) {
                data.data.forEach(item => {
                    if (str_starts_with(item.role, 'admin_')) {
                        const category = getRoleCategory(item.role);
                        if (category && !adminCategories.includes(category)) adminCategories.push(category);
                    }
                });
            } else {
                if (str_starts_with(user.role, 'admin_')) {
                    const category = getRoleCategory(user.role);
                    if (category) adminCategories.push(category);
                }
            }
            const userRoles = [];
            adminCategories.forEach(category => {
                userRoles.push({ value: `user_${category}`, label: `User ${category.charAt(0).toUpperCase() + category.slice(1)}` });
                userRoles.push({ value: `manager_${category}`, label: `Manager ${category.charAt(0).toUpperCase() + category.slice(1)}` });
                // userRoles.push({ value: `viewer_${category}`, label: `Viewer ${category.charAt(0).toUpperCase() + category.slice(1)}` });
            });
            setAllUserRoles(userRoles);
        } catch (error) {
            console.error('Error loading user roles for admin:', error);
            setAllUserRoles(generateAllUserRoles());
        }
    }, [user?.role, user?.id]);

    const generateAllUserRoles = useCallback(() => {
        const allCategories = ['pos', 'fabrics', 'mechanicsth', 'mechanicsap', 'hardwareth', 'hardwareap','pharmacy','cosmetics','solar','electronics'];
        const userRoles = [];
        allCategories.forEach(category => {
            userRoles.push({ value: `user_${category}`, label: `User ${category.charAt(0).toUpperCase() + category.slice(1)}` });
            userRoles.push({ value: `manager_${category}`, label: `Manager ${category.charAt(0).toUpperCase() + category.slice(1)}` });
            // userRoles.push({ value: `viewer_${category}`, label: `Viewer ${category.charAt(0).toUpperCase() + category.slice(1)}` });
        });
        return userRoles;
    }, []);

    const loadAdminAvailableShops = useCallback(async () => {
        if (!user?.id) return [];
        try {
            const response = await fetch(`https://ourzestapp.online/oz_backend/root_users.php?action=get_admin_shops&admin_id=${user.id}`);
            const data = await response.json();
            if (data.success) {
                setAdminAvailableShops(data.data || []);
                return data.data || [];
            }
            if (user.shops) {
                try {
                    const adminShopIds = JSON.parse(user.shops);
                    const adminShops = shops.filter(shop => shop.status === 'active' && adminShopIds.includes(shop.shop_id));
                    setAdminAvailableShops(adminShops);
                    return adminShops;
                } catch (e) {
                    console.error('Error parsing admin shops:', e);
                }
            }
            setAdminAvailableShops([]);
            return [];
        } catch (error) {
            console.error('Error loading admin shops:', error);
            setAdminAvailableShops([]);
            return [];
        }
    }, [user?.id, user?.shops, shops]);

    const getAvailableShopsForAssignment = useCallback(async () => {
        if (!user?.id) return [];
        if (user?.role === 'super_admin') {
            return shops.filter(shop => shop.status === 'active');
        } else if (user?.role?.startsWith('admin_')) {
            return adminAvailableShops;
        }
        return [];
    }, [user?.id, user?.role, shops, adminAvailableShops]);

    const getAvailableRolesForShop = useCallback((shopCategory = '') => {
        if (user?.role === 'super_admin') return allAdminRoles;
        if (str_starts_with(user?.role, 'admin_')) {
            if (shopCategory) {
                return allUserRoles.filter(role => str_ends_with(role.value, `_${shopCategory}`));
            }
            return allUserRoles;
        }
        return allAdminRoles;
    }, [user?.role, allAdminRoles, allUserRoles]);

    const getRolesForShop = useCallback((shopId) => {
        const shop = availableShopsForAssignment.find(s => s.shop_id === shopId);
        if (!shop) return getAvailableRolesForShop();
        let shopCategory = '';
        if (shop.shop_name) {
            const shopLower = shop.shop_name.toLowerCase();
            if (shopLower.includes('pos')) shopCategory = 'pos';
            else if (shopLower.includes('fabric')) shopCategory = 'fabrics';
            else if (shopLower.includes('pharma')) shopCategory = 'pharmacy';
            else if (shopLower.includes('hostel')) shopCategory = 'hostel';
            else if (shopLower.includes('inventory')) shopCategory = 'inventory';
        }
        return getAvailableRolesForShop(shopCategory);
    }, [availableShopsForAssignment, getAvailableRolesForShop]);

    // ==============================================
    // FETCH APPLICATIONS FOR SUBSCRIPTION
    // ==============================================
    const fetchApplications = useCallback(async () => {
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php?action=get_applications');
            const data = await response.json();
            if (data.success) {
                setApplications(data.data || []);
                if (data.data && data.data.length > 0) {
                    setSubscriptionData(prev => ({
                        ...prev,
                        application_id: data.data[0].id
                    }));
                }
            } else {
                console.error('Failed to fetch applications:', data.error);
            }
        } catch (error) {
            console.error('Error fetching applications:', error);
        }
    }, []);

    // ==============================================
    // FETCH SUBSCRIPTION STATS
    // ==============================================
    const fetchSubscriptionStats = useCallback(async () => {
        if (!isSuperAdmin) return;
        setStatsLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/root_subscriptions.php?action=get_stats');
            const data = await response.json();
            if (data.success) {
                setSubscriptionStats(data.data || {
                    total_customers: 0,
                    active_subscriptions: 0,
                    expiring_this_month: 0,
                    expired_accounts: 0,
                    outstanding_dues: 0,
                    revenue_this_month: 0,
                    revenue_this_year: 0,
                    by_plan_type: [],
                    by_status: [],
                    by_payment_status: [],
                    by_application: [],
                    customers_with_active: 0,
                    customers_without_active: 0
                });
            }
        } catch (error) {
            console.error('Error fetching subscription stats:', error);
        } finally {
            setStatsLoading(false);
        }
    }, [isSuperAdmin]);

    // ==============================================
    // FETCH USER SUBSCRIPTIONS
    // ==============================================
    const fetchUserSubscriptions = useCallback(async (userId) => {
        if (!userId) return [];
        setSubscriptionLoading(true);
        try {
            const response = await fetch(`https://ourzestapp.online/oz_backend/root_subscriptions.php?action=get_customer_subscriptions&user_id=${userId}`);
            const data = await response.json();
            if (data.success) {
                setSelectedUserSubscriptions(data.data || []);
                return data.data || [];
            }
            return [];
        } catch (error) {
            console.error('Error fetching user subscriptions:', error);
            return [];
        } finally {
            setSubscriptionLoading(false);
        }
    }, []);

    // ==============================================
    // CREATE SUBSCRIPTION FOR USER
    // ==============================================
    const createSubscriptionForUser = useCallback(async (userId, subscriptionData) => {
        try {
            const payload = {
                action: 'create',
                root_user_id: userId,
                application_id: parseInt(subscriptionData.application_id),
                plan_type: subscriptionData.plan_type,
                amount: parseFloat(subscriptionData.amount) || 0,
                start_date: subscriptionData.start_date,
                created_by: user.id,
                status: 'active',
                auto_suspend: 1,
                grace_period_days: subscriptionData.grace_period_days || 7,
                payment_status: 'unpaid'
            };

            const response = await fetch('https://ourzestapp.online/oz_backend/root_subscriptions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Error creating subscription:', error);
            return { success: false, error: error.message };
        }
    }, [user.id]);

    // ==============================================
    // RENEW SUBSCRIPTION
    // ==============================================
    const renewUserSubscription = useCallback(async (subscriptionId) => {
        setRenewingSubscription(subscriptionId);
        try {
            const payload = {
                action: 'renew',
                subscription_id: subscriptionId,
                performed_by: user.id
            };

            const response = await fetch('https://ourzestapp.online/oz_backend/root_subscriptions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (data.success) {
                showToast('success', 'Subscription renewed successfully!');
                if (selectedUser) {
                    await fetchUserSubscriptions(selectedUser.id);
                }
                loadUsers();
            } else {
                showToast('error', data.error || 'Failed to renew subscription');
            }
            return data;
        } catch (error) {
            console.error('Error renewing subscription:', error);
            showToast('error', 'Network error while renewing subscription');
            return { success: false, error: error.message };
        } finally {
            setRenewingSubscription(null);
        }
    }, [user.id, selectedUser, fetchUserSubscriptions, loadUsers, showToast]);

    // ==============================================
    // UPDATE SUBSCRIPTION STATUS
    // ==============================================
    const updateSubscriptionStatus = useCallback(async (subscriptionId, status) => {
        try {
            const payload = {
                action: 'update_status',
                subscription_id: subscriptionId,
                status: status,
                performed_by: user.id
            };

            const response = await fetch('https://ourzestapp.online/oz_backend/root_subscriptions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (data.success) {
                showToast('success', `Subscription status updated to ${status}`);
                if (selectedUser) {
                    await fetchUserSubscriptions(selectedUser.id);
                }
                loadUsers();
            } else {
                showToast('error', data.error || 'Failed to update subscription status');
            }
            return data;
        } catch (error) {
            console.error('Error updating subscription status:', error);
            showToast('error', 'Network error while updating subscription');
            return { success: false, error: error.message };
        }
    }, [user.id, selectedUser, fetchUserSubscriptions, loadUsers, showToast]);

    // ==============================================
    // UPDATE PAYMENT STATUS
    // ==============================================
    const updatePaymentStatus = useCallback(async (subscriptionId, paymentStatus) => {
        try {
            const payload = {
                action: 'update_payment',
                subscription_id: subscriptionId,
                payment_status: paymentStatus,
                performed_by: user.id
            };

            const response = await fetch('https://ourzestapp.online/oz_backend/root_subscriptions.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (data.success) {
                showToast('success', `Payment status updated to ${paymentStatus}`);
                if (selectedUser) {
                    await fetchUserSubscriptions(selectedUser.id);
                }
                loadUsers();
            } else {
                showToast('error', data.error || 'Failed to update payment status');
            }
            return data;
        } catch (error) {
            console.error('Error updating payment status:', error);
            showToast('error', 'Network error while updating payment status');
            return { success: false, error: error.message };
        }
    }, [user.id, selectedUser, fetchUserSubscriptions, loadUsers, showToast]);

    // ==============================================
    // DELETE SUBSCRIPTION
    // ==============================================
    const deleteSubscription = useCallback(async (subscriptionId) => {
        if (!window.confirm('Are you sure you want to cancel this subscription?')) return;

        try {
            const payload = {
                action: 'delete',
                subscription_id: subscriptionId,
                performed_by: user.id
            };

            const response = await fetch('https://ourzestapp.online/oz_backend/root_subscriptions.php', {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await response.json();

            if (data.success) {
                showToast('success', 'Subscription cancelled successfully');
                if (selectedUser) {
                    await fetchUserSubscriptions(selectedUser.id);
                }
                loadUsers();
            } else {
                showToast('error', data.error || 'Failed to cancel subscription');
            }
            return data;
        } catch (error) {
            console.error('Error deleting subscription:', error);
            showToast('error', 'Network error while cancelling subscription');
            return { success: false, error: error.message };
        }
    }, [user.id, selectedUser, fetchUserSubscriptions, loadUsers, showToast]);

    // ==============================================
    // SUBSCRIPTION STATUS RENDER FUNCTION
    // ==============================================
    const renderSubscriptionStatus = useCallback((userData) => {
        if (!userData || !userData.subscription) {
            return <span className="subscription-status none">{translations?.noSubscription || 'No Subscription'}</span>;
        }

        const sub = userData.subscription;
        const isInherited = sub.is_inherited || false;
        const hasActive = sub.has_active || false;
        const isAdminUser = userData.is_admin_user || false;
        const daysRemaining = sub.days_remaining;

        // If user is ADMIN - show their own subscription
        if (isAdminUser) {
            if (hasActive) {
                let statusColor = 'active';
                let statusLabel = translations?.activeSubscription || 'Active';
                if (daysRemaining !== null && daysRemaining <= 3) {
                    statusColor = 'critical';
                    statusLabel = 'Expiring Soon (Urgent)';
                } else if (daysRemaining !== null && daysRemaining <= 7) {
                    statusColor = 'warning';
                    statusLabel = 'Expiring This Week';
                } else if (daysRemaining !== null && daysRemaining <= 15) {
                    statusColor = 'warning';
                    statusLabel = 'Expiring Soon';
                } else if (daysRemaining !== null && daysRemaining <= 30) {
                    statusColor = 'info';
                    statusLabel = 'Expiring This Month';
                }

                return (
                    <span className={`subscription-status ${statusColor}`} title={translations?.adminSubscription || 'Admin Subscription'}>
                        <FontAwesomeIcon icon={faCrown} className="status-icon" />
                        <span className="status-text">{statusLabel}</span>
                        {daysRemaining !== null && (
                            <span className="days-badge">{daysRemaining}d</span>
                        )}
                    </span>
                );
            }
            return (
                <span className="subscription-status none">
                    <FontAwesomeIcon icon={faTimesCircle} className="status-icon" />
                    <span className="status-text">{translations?.noSubscription || 'No Subscription'}</span>
                </span>
            );
        }

        // User is NOT admin - check if inherited
        if (hasActive && isInherited) {
            const fromName = sub.inherited_from_name || 'Admin';
            return (
                <span className="subscription-status inherited" title={`${translations?.inheritedFrom || 'Inherited from'}: ${fromName}`}>
                    <FontAwesomeIcon icon={faShare} className="inherited-icon" />
                    <span className="status-text">{translations?.inherited || 'Inherited'}</span>
                    {daysRemaining !== null && daysRemaining <= 30 && (
                        <span className="days-badge">{daysRemaining}d</span>
                    )}
                    <span className="inherited-tooltip">{translations?.inheritedFrom || 'Inherited from'}: {fromName}</span>
                </span>
            );
        }

        // No subscription at all
        return (
            <span className="subscription-status none">
                <FontAwesomeIcon icon={faTimesCircle} className="status-icon" />
                <span className="status-text">{translations?.noSubscription || 'No Subscription'}</span>
            </span>
        );
    }, [translations]);

    // ==============================================
    // RENDER SUBSCRIPTION DETAILS IN MODAL
    // ==============================================
    const renderSubscriptionDetailsModal = useCallback(() => {
        if (!selectedUser) return null;

        const isAdminUser = selectedUser.is_admin_user || false;
        const hasSubscriptions = selectedUserSubscriptions.length > 0;

        return (
            <div className="subscription-details-modal">
                <div className="subscription-details-header">
                    <h3>
                        <FontAwesomeIcon icon={faCreditCardIcon} />
                        {translations?.subscriptionDetails || 'Subscription Details'}
                        <span className="subscription-user-name">
                            {selectedUser.fullname || selectedUser.username}
                        </span>
                    </h3>
                    {isAdminUser && (
                        <span className="admin-tag">
                            <FontAwesomeIcon icon={faCrown} /> Admin
                        </span>
                    )}
                    {selectedUser.subscription?.is_inherited && (
                        <span className="inherited-tag">
                            <FontAwesomeIcon icon={faShare} />
                            Inherited from {selectedUser.subscription.inherited_from_name}
                        </span>
                    )}
                </div>

                {subscriptionLoading ? (
                    <div className="subscription-loading">
                        <div className="spinner"></div>
                        <span>Loading subscriptions...</span>
                    </div>
                ) : !hasSubscriptions ? (
                    <div className="no-subscriptions">
                        <FontAwesomeIcon icon={faTimesCircle} />
                        <p>{translations?.noSubscription || 'No subscriptions found for this user'}</p>
                        {isSuperAdmin && (
                            <button
                                className="btn btn-primary btn-sm"
                                onClick={() => setShowSubscriptionSection(true)}
                            >
                                <FontAwesomeIcon icon={faPlus} /> Add Subscription
                            </button>
                        )}
                    </div>
                ) : (
                    <div className="subscription-list">
                        {selectedUserSubscriptions.map((sub, index) => {
                            const daysRemaining = sub.days_remaining;
                            let statusColor = 'active';
                            let statusIcon = faCheckCircle;

                            if (sub.status === 'expired') {
                                statusColor = 'expired';
                                statusIcon = faTimesCircle;
                            } else if (sub.status === 'cancelled') {
                                statusColor = 'cancelled';
                                statusIcon = faBan;
                            } else if (sub.status === 'suspended') {
                                statusColor = 'suspended';
                                statusIcon = faBan;
                            } else if (sub.status === 'grace_period') {
                                statusColor = 'grace-period';
                                statusIcon = faClockIcon;
                            } else if (daysRemaining !== null && daysRemaining <= 3) {
                                statusColor = 'critical';
                                statusIcon = faExclamationTriangle;
                            } else if (daysRemaining !== null && daysRemaining <= 7) {
                                statusColor = 'warning';
                                statusIcon = faTriangleExclamation;
                            } else if (daysRemaining !== null && daysRemaining <= 15) {
                                statusColor = 'warning';
                                statusIcon = faCircleInfo;
                            } else if (daysRemaining !== null && daysRemaining <= 30) {
                                statusColor = 'info';
                                statusIcon = faCircleInfo;
                            }

                            return (
                                <div key={sub.id || index} className={`subscription-item status-${statusColor}`}>
                                    <div className="subscription-item-header">
                                        <div className="subscription-app-info">
                                            <span className="app-name">{sub.app_name || sub.app_code || 'Application'}</span>
                                            <span className="plan-type">{sub.plan_type}</span>
                                        </div>
                                        <div className="subscription-status-badge">
                                            <FontAwesomeIcon icon={statusIcon} />
                                            <span>{sub.status}</span>
                                        </div>
                                    </div>
                                    <div className="subscription-item-body">
                                        <div className="subscription-dates">
                                            <div className="date-group">
                                                <label>{translations?.startDate || 'Start'}</label>
                                                <span>{sub.start_date}</span>
                                            </div>
                                            <div className="date-group">
                                                <label>{translations?.expiryDate || 'Expiry'}</label>
                                                <span>{sub.expiry_date}</span>
                                            </div>
                                            <div className="date-group">
                                                <label>Days</label>
                                                <span className={`days-remaining ${daysRemaining < 0 ? 'expired' : daysRemaining <= 7 ? 'urgent' : ''}`}>
                                                    {daysRemaining !== null ? (daysRemaining < 0 ? 'Expired' : `${daysRemaining} days`) : 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="subscription-amount">
                                            <span className="amount">${sub.amount}</span>
                                            <span className={`payment-status ${sub.payment_status}`}>
                                                {sub.payment_status}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="subscription-item-actions">
                                        {sub.status === 'active' && (
                                            <button
                                                className="btn btn-success btn-sm"
                                                onClick={() => renewUserSubscription(sub.id)}
                                                disabled={renewingSubscription === sub.id}
                                            >
                                                {renewingSubscription === sub.id ? (
                                                    <><div className="spinner-small"></div> Renewing...</>
                                                ) : (
                                                    <><FontAwesomeIcon icon={faExchangeAlt} /> Renew</>
                                                )}
                                            </button>
                                        )}
                                        <button
                                            className="btn btn-info btn-sm"
                                            onClick={() => updatePaymentStatus(sub.id, sub.payment_status === 'paid' ? 'unpaid' : 'paid')}
                                        >
                                            <FontAwesomeIcon icon={faMoneyBillWave} /> Toggle Payment
                                        </button>
                                        {['active', 'grace_period'].includes(sub.status) && (
                                            <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => updateSubscriptionStatus(sub.id, 'cancelled')}
                                            >
                                                <FontAwesomeIcon icon={faBan} /> Cancel
                                            </button>
                                        )}
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => deleteSubscription(sub.id)}
                                        >
                                            <FontAwesomeIcon icon={faTrash} />
                                        </button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {isSuperAdmin && showSubscriptionSection && (
                    <div className="subscription-form-section">
                        <div className="subscription-form-header">
                            <h4><FontAwesomeIcon icon={faPlus} /> Add New Subscription</h4>
                            <button
                                className="btn-close"
                                onClick={() => setShowSubscriptionSection(false)}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="subscription-form-grid">
                            <div className="form-group">
                                <label>{translations?.application || 'Application'} <span className="required">*</span></label>
                                <select
                                    value={subscriptionData.application_id}
                                    onChange={(e) => setSubscriptionData(prev => ({ ...prev, application_id: e.target.value }))}
                                    className="form-select"
                                >
                                    <option value="">Select Application</option>
                                    {applications.map(app => (
                                        <option key={app.id} value={app.id}>
                                            {app.app_name} ({app.app_code})
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label>{translations?.planType || 'Plan'} <span className="required">*</span></label>
                                <select
                                    value={subscriptionData.plan_type}
                                    onChange={(e) => setSubscriptionData(prev => ({ ...prev, plan_type: e.target.value }))}
                                    className="form-select"
                                >
                                    <option value="monthly">{translations?.monthly || 'Monthly'}</option>
                                    <option value="yearly">{translations?.yearly || 'Yearly'}</option>
                                    <option value="custom">{translations?.custom || 'Custom'}</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>{translations?.amount || 'Amount'} <span className="required">*</span></label>
                                <input
                                    type="number"
                                    step="0.01"
                                    value={subscriptionData.amount}
                                    onChange={(e) => setSubscriptionData(prev => ({ ...prev, amount: e.target.value }))}
                                    className="form-input"
                                    placeholder="0.00"
                                />
                            </div>
                            <div className="form-group">
                                <label>{translations?.startDate || 'Start Date'} <span className="required">*</span></label>
                                <input
                                    type="date"
                                    value={subscriptionData.start_date}
                                    onChange={(e) => setSubscriptionData(prev => ({ ...prev, start_date: e.target.value }))}
                                    className="form-input"
                                />
                            </div>
                            <div className="form-group">
                                <label>Grace Period (Days)</label>
                                <input
                                    type="number"
                                    value={subscriptionData.grace_period_days}
                                    onChange={(e) => setSubscriptionData(prev => ({ ...prev, grace_period_days: parseInt(e.target.value) || 7 }))}
                                    className="form-input"
                                    min="1"
                                    max="30"
                                />
                            </div>
                            <div className="form-group checkbox-group">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        checked={subscriptionData.auto_renew}
                                        onChange={(e) => setSubscriptionData(prev => ({ ...prev, auto_renew: e.target.checked }))}
                                    />
                                    Auto Renew
                                </label>
                            </div>
                        </div>
                        <div className="subscription-form-actions">
                            <button
                                className="btn btn-primary"
                                onClick={async () => {
                                    if (!subscriptionData.application_id) {
                                        showToast('error', 'Please select an application');
                                        return;
                                    }
                                    const result = await createSubscriptionForUser(selectedUser.id, subscriptionData);
                                    if (result.success) {
                                        showToast('success', 'Subscription created successfully!');
                                        setShowSubscriptionSection(false);
                                        await fetchUserSubscriptions(selectedUser.id);
                                        loadUsers();
                                    } else {
                                        showToast('error', result.error || 'Failed to create subscription');
                                    }
                                }}
                            >
                                <FontAwesomeIcon icon={faSave} /> Create Subscription
                            </button>
                            <button
                                className="btn btn-secondary"
                                onClick={() => setShowSubscriptionSection(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                )}
            </div>
        );
    }, [selectedUser, selectedUserSubscriptions, subscriptionLoading, isSuperAdmin,
        applications, subscriptionData, showSubscriptionSection, renewUserSubscription,
        renewingSubscription, updatePaymentStatus, updateSubscriptionStatus, deleteSubscription,
        createSubscriptionForUser, fetchUserSubscriptions, loadUsers, showToast, translations]);

    // ==============================================
    // SUBSCRIPTION STATS DASHBOARD
    // ==============================================
    const renderSubscriptionStats = useCallback(() => {
        if (!isSuperAdmin || !showSubscriptionStats) return null;

        const stats = subscriptionStats;

        return (
            <div className="subscription-stats-dashboard">
                <div className="stats-header">
                    <h3><FontAwesomeIcon icon={faChartBar} /> Subscription Analytics</h3>
                    <button
                        className="btn-close"
                        onClick={() => setShowSubscriptionStats(false)}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="stats-grid">
                    <div className="stat-card">
                        <div className="stat-icon primary"><FontAwesomeIcon icon={faUsers} /></div>
                        <div className="stat-info">
                            <h4>{stats.total_customers}</h4>
                            <p>Total Customers</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon success"><FontAwesomeIcon icon={faCheckCircle} /></div>
                        <div className="stat-info">
                            <h4>{stats.active_subscriptions}</h4>
                            <p>Active Subscriptions</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon warning"><FontAwesomeIcon icon={faClockIcon} /></div>
                        <div className="stat-info">
                            <h4>{stats.expiring_this_month}</h4>
                            <p>Expiring This Month</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon danger"><FontAwesomeIcon icon={faBan} /></div>
                        <div className="stat-info">
                            <h4>{stats.expired_accounts}</h4>
                            <p>Expired Accounts</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon warning"><FontAwesomeIcon icon={faMoneyBillWave} /></div>
                        <div className="stat-info">
                            <h4>${stats.outstanding_dues}</h4>
                            <p>Outstanding Dues</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon primary"><FontAwesomeIcon icon={faMoneyBill} /></div>
                        <div className="stat-info">
                            <h4>${stats.revenue_this_month}</h4>
                            <p>Revenue This Month</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon success"><FontAwesomeIcon icon={faChartBar} /></div>
                        <div className="stat-info">
                            <h4>${stats.revenue_this_year}</h4>
                            <p>Revenue This Year</p>
                        </div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-icon info"><FontAwesomeIcon icon={faUsers} /></div>
                        <div className="stat-info">
                            <h4>{stats.customers_with_active || 0}</h4>
                            <p>Customers with Active</p>
                        </div>
                    </div>
                </div>

                <div className="stats-charts">
                    <div className="chart-section">
                        <h4>By Plan Type</h4>
                        <div className="chart-bars">
                            {stats.by_plan_type && stats.by_plan_type.map((item, index) => (
                                <div key={index} className="chart-bar">
                                    <span className="label">{item.plan_type}</span>
                                    <div className="bar-track">
                                        <div className="bar-fill" style={{ width: `${(item.count / (stats.by_plan_type.reduce((a, b) => a + b.count, 0) || 1)) * 100}%` }}></div>
                                    </div>
                                    <span className="value">{item.count}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="chart-section">
                        <h4>By Status</h4>
                        <div className="chart-bars">
                            {stats.by_status && stats.by_status.map((item, index) => (
                                <div key={index} className="chart-bar">
                                    <span className="label">{item.status}</span>
                                    <div className="bar-track">
                                        <div className="bar-fill" style={{ width: `${(item.count / (stats.by_status.reduce((a, b) => a + b.count, 0) || 1)) * 100}%` }}></div>
                                    </div>
                                    <span className="value">{item.count}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="chart-section">
                        <h4>By Payment Status</h4>
                        <div className="chart-bars">
                            {stats.by_payment_status && stats.by_payment_status.map((item, index) => (
                                <div key={index} className="chart-bar">
                                    <span className="label">{item.payment_status}</span>
                                    <div className="bar-track">
                                        <div className="bar-fill" style={{ width: `${(item.count / (stats.by_payment_status.reduce((a, b) => a + b.count, 0) || 1)) * 100}%` }}></div>
                                    </div>
                                    <span className="value">{item.count}</span>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="chart-section">
                        <h4>By Application</h4>
                        <div className="chart-bars">
                            {stats.by_application && stats.by_application.map((item, index) => (
                                <div key={index} className="chart-bar">
                                    <span className="label">{item.app_name || 'Unknown'}</span>
                                    <div className="bar-track">
                                        <div className="bar-fill" style={{ width: `${(item.count / (stats.by_application.reduce((a, b) => a + b.count, 0) || 1)) * 100}%` }}></div>
                                    </div>
                                    <span className="value">{item.count}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [isSuperAdmin, showSubscriptionStats, subscriptionStats]);

    // ==============================================
    // PASSWORD UPDATE FUNCTIONS
    // ==============================================
    const openPasswordModal = (userData) => {
        setPasswordFormData({
            userId: userData.id,
            newPassword: '',
            confirmPassword: '',
        });
        setPasswordErrors({});
        setPasswordModalOpen(true);
        setSelectedUser(userData);
    };

    const closePasswordModal = () => {
        setPasswordModalOpen(false);
        setPasswordFormData({
            userId: null,
            newPassword: '',
            confirmPassword: '',
        });
        setPasswordErrors({});
        setSelectedUser(null);
    };

    const validatePasswordForm = () => {
        const errors = {};
        if (!passwordFormData.newPassword || passwordFormData.newPassword.length < 5) {
            errors.newPassword = translations?.passwordMinLength || 'Password must be at least 5 characters';
        }
        if (passwordFormData.newPassword !== passwordFormData.confirmPassword) {
            errors.confirmPassword = translations?.passwordsDoNotMatch || 'Passwords do not match';
        }
        setPasswordErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handlePasswordUpdate = async (e) => {
        e.preventDefault();
        if (!validatePasswordForm()) return;

        setUpdatingPassword(true);
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('action', 'update_password');
            formDataToSend.append('user_id', passwordFormData.userId);
            formDataToSend.append('password', passwordFormData.newPassword);
            formDataToSend.append('current_user_id', user.id);
            formDataToSend.append('current_user_role', user.role);

            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php', {
                method: 'POST',
                body: formDataToSend
            });
            const data = await response.json();

            if (data.success) {
                showToast('success', translations?.passwordUpdated || 'Password updated successfully!');
                closePasswordModal();
                loadUsers();
            } else {
                throw new Error(data.error || 'Failed to update password');
            }
        } catch (error) {
            console.error('Password update error:', error);
            showToast('error', error.message);
        } finally {
            setUpdatingPassword(false);
        }
    };

    // ==============================================
    // PERMISSION HELPER FUNCTIONS
    // ==============================================
    const canEditUser = (targetUser) => {
        if (isSuperAdmin) return true;
        if (!isAdmin) return false;
        if (targetUser.id === user.id) return false;
        if (targetUser.role === user.role) return true;
        if (targetUser.created_by === user.id) return true;
        if (targetUser.parent_business_name === user.businessname) return true;
        return false;
    };

    const canChangePassword = (targetUser) => {
        if (isSuperAdmin) return true;
        if (isAdmin && targetUser.id === user.id) return true;
        if (isAdmin && targetUser.role === user.role) return true;
        if (isAdmin && targetUser.created_by === user.id) return true;
        if (isAdmin && targetUser.parent_business_name === user.businessname) return true;
        return false;
    };

    const canDeleteUser = (targetUser) => {
        if (isSuperAdmin) return true;
        if (targetUser.id === user.id) return false;
        if (isAdmin && targetUser.role === user.role) return true;
        if (isAdmin && targetUser.created_by === user.id) return true;
        if (isAdmin && targetUser.parent_business_name === user.businessname) return true;
        return false;
    };

    // ==============================================
    // FETCH ALL LOGIN HISTORY
    // ==============================================
    const fetchAllLoginHistory = async () => {
        if (!isSuperAdmin) {
            showToast('error', 'You do not have permission to view login history');
            return;
        }

        setLoadingAllHistory(true);
        try {
            const response = await fetch(`https://ourzestapp.online/oz_backend/root_users.php?action=get_all_login_history&limit=1000`);
            const data = await response.json();

            if (data.success) {
                setAllLoginHistory(data.data);
                applyHistoryFilters(data.data);
            } else {
                showToast('error', data.error || 'Failed to load login history');
            }
        } catch (error) {
            console.error('Error fetching login history:', error);
            showToast('error', 'Network error while fetching login history');
        } finally {
            setLoadingAllHistory(false);
        }
    };

    // Apply filters to history
    const applyHistoryFilters = (data = allLoginHistory) => {
        let filtered = [...data];

        if (historyFilters.search) {
            const searchLower = historyFilters.search.toLowerCase();
            filtered = filtered.filter(record =>
                (record.username && record.username.toLowerCase().includes(searchLower)) ||
                (record.fullname && record.fullname.toLowerCase().includes(searchLower)) ||
                (record.ip_address && record.ip_address.includes(searchLower)) ||
                (record.browser_name && record.browser_name.toLowerCase().includes(searchLower)) ||
                (record.os_name && record.os_name.toLowerCase().includes(searchLower))
            );
        }

        if (historyFilters.dateFrom) {
            filtered = filtered.filter(record =>
                new Date(record.login_time) >= new Date(historyFilters.dateFrom)
            );
        }
        if (historyFilters.dateTo) {
            filtered = filtered.filter(record =>
                new Date(record.login_time) <= new Date(historyFilters.dateTo + 'T23:59:59')
            );
        }

        if (historyFilters.deviceType) {
            filtered = filtered.filter(record =>
                record.device_type === historyFilters.deviceType
            );
        }

        if (historyFilters.browser) {
            filtered = filtered.filter(record =>
                record.browser_name === historyFilters.browser
            );
        }

        if (historyFilters.os) {
            filtered = filtered.filter(record =>
                record.os_name === historyFilters.os
            );
        }

        if (historyFilters.status) {
            filtered = filtered.filter(record =>
                record.login_status === historyFilters.status
            );
        }

        if (historyFilters.ipAddress) {
            filtered = filtered.filter(record =>
                record.ip_address && record.ip_address.includes(historyFilters.ipAddress)
            );
        }

        filtered.sort((a, b) => new Date(b.login_time) - new Date(a.login_time));

        setFilteredHistory(filtered);
        setHistoryPagination(prev => ({
            ...prev,
            total: filtered.length,
            pages: Math.ceil(filtered.length / prev.limit),
            page: 1
        }));
    };

    const handleHistoryFilterChange = (key, value) => {
        setHistoryFilters(prev => ({ ...prev, [key]: value }));
        setTimeout(() => applyHistoryFilters(), 100);
    };

    const clearHistoryFilters = () => {
        setHistoryFilters({
            search: '',
            dateFrom: '',
            dateTo: '',
            deviceType: '',
            browser: '',
            os: '',
            status: '',
            ipAddress: ''
        });
        setTimeout(() => applyHistoryFilters(), 100);
    };

    const exportToPDF = () => {
        setExporting(true);
        try {
            const printWindow = window.open('', '_blank');
            const currentDate = new Date().toLocaleString();

            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Login History Report</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 20px; }
                        h1 { color: #333; border-bottom: 2px solid #333; padding-bottom: 10px; }
                        .header { margin-bottom: 20px; }
                        .filters { background: #f5f5f5; padding: 10px; margin-bottom: 20px; font-size: 12px; }
                        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; font-size: 11px; }
                        th { background-color: #4CAF50; color: white; }
                        tr:nth-child(even) { background-color: #f2f2f2; }
                        .footer { margin-top: 20px; text-align: center; font-size: 10px; color: #666; }
                    </style>
                </head>
                <body>
                    <div class="header">
                        <h1>Login History Report</h1>
                        <p>Generated: ${currentDate}</p>
                        <p>Total Records: ${filteredHistory.length}</p>
                    </div>
                    <div class="filters">
                        <strong>Applied Filters:</strong><br>
                        ${historyFilters.search ? `Search: ${historyFilters.search}<br>` : ''}
                        ${historyFilters.dateFrom ? `Date From: ${historyFilters.dateFrom}<br>` : ''}
                        ${historyFilters.dateTo ? `Date To: ${historyFilters.dateTo}<br>` : ''}
                        ${historyFilters.deviceType ? `Device: ${historyFilters.deviceType}<br>` : ''}
                        ${historyFilters.browser ? `Browser: ${historyFilters.browser}<br>` : ''}
                        ${historyFilters.os ? `OS: ${historyFilters.os}<br>` : ''}
                        ${historyFilters.status ? `Status: ${historyFilters.status}<br>` : ''}
                    </div>
                    <table>
                        <thead>
                            <tr><th>User</th><th>Full Name</th><th>Date & Time</th><th>IP Address</th><th>Device</th><th>Browser</th><th>OS</th><th>Status</th><th>Duration</th></tr>
                        </thead>
                        <tbody>
                            ${filteredHistory.slice(0, 500).map(record => `
                                <tr>
                                    <td>${record.username || 'N/A'}</td>
                                    <td>${record.fullname || 'N/A'}</td>
                                    <td>${new Date(record.login_time).toLocaleString()}</td>
                                    <td>${record.ip_address}</td>
                                    <td>${record.device_type || 'Desktop'}</td>
                                    <td>${record.browser_name || 'Unknown'}</td>
                                    <td>${record.os_name || 'Unknown'}</td>
                                    <td>${record.login_status === 'success' ? 'Success' : 'Failed'}</td>
                                    <td>${record.session_duration || 'Active'}</td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                    <div class="footer"><p>Generated by OurZest System - Login History Report</p></div>
                </body>
                </html>
            `);
            printWindow.document.close();
            printWindow.print();
        } catch (error) {
            console.error('Error exporting to PDF:', error);
            showToast('error', 'Failed to generate PDF');
        } finally {
            setExporting(false);
        }
    };

    const exportToCSV = () => {
        setExporting(true);
        try {
            const headers = ['User', 'Full Name', 'Date & Time', 'IP Address', 'Device', 'Browser', 'Browser Version', 'OS', 'OS Version', 'Status', 'Duration'];
            const rows = filteredHistory.map(record => [
                record.username || 'N/A',
                record.fullname || 'N/A',
                new Date(record.login_time).toLocaleString(),
                record.ip_address,
                record.device_type || 'Desktop',
                record.browser_name || 'Unknown',
                record.browser_version || '',
                record.os_name || 'Unknown',
                record.os_version || '',
                record.login_status === 'success' ? 'Success' : 'Failed',
                record.session_duration || 'Active'
            ]);

            const csvContent = [headers, ...rows].map(row => row.map(cell => `"${cell}"`).join(',')).join('\n');
            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', `login_history_${new Date().toISOString().split('T')[0]}.csv`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            showToast('success', 'CSV exported successfully');
        } catch (error) {
            console.error('Error exporting to CSV:', error);
            showToast('error', 'Failed to export CSV');
        } finally {
            setExporting(false);
        }
    };

    const toggleHistoryView = () => {
        if (!isSuperAdmin) {
            showToast('error', 'You do not have permission to view login history');
            return;
        }

        if (!showHistoryView) {
            fetchAllLoginHistory();
        }
        setShowHistoryView(!showHistoryView);
        setHistoryPagination(prev => ({ ...prev, page: 1 }));
    };

    const getPaginatedHistory = () => {
        const start = (historyPagination.page - 1) * historyPagination.limit;
        const end = start + historyPagination.limit;
        return filteredHistory.slice(start, end);
    };

    // ==============================================
    // FORM VALIDATION
    // ==============================================
    const validateForm = () => {
        const newErrors = {};
        if (!formData.username.trim()) newErrors.username = translations?.usernameRequired || 'Username is required';
        if (!formData.email.trim()) {
            newErrors.email = translations?.emailRequired || 'Email is required';
        } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
            newErrors.email = translations?.invalidEmail || 'Invalid email address';
        }
        if (modalType === 'add' && !formData.password) {
            newErrors.password = translations?.passwordRequired || 'Password is required';
        } else if (formData.password && formData.password.length < 5) {
            newErrors.password = translations?.passwordMinLength || 'Password must be at least 5 characters';
        }
        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = translations?.passwordsDoNotMatch || 'Passwords do not match';
        }
        if (!formData.fullname.trim()) newErrors.fullname = translations?.fullNameRequired || 'Full name is required';

        for (let i = 0; i < shopRolesData.length; i++) {
            if (!shopRolesData[i].role) {
                newErrors[`shop_role_${i}`] = `Please select a role for ${shopRolesData[i].shop_name || `Shop #${shopRolesData[i].shop_id}`}`;
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ==============================================
    // FORM HANDLERS
    // ==============================================
    const handleFormChange = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? (checked ? 1 : 0) : value;
        setFormData(prev => ({ ...prev, [name]: newValue }));
        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleFileChange = (e, field) => {
        const file = e.target.files[0];
        if (file) setFormData(prev => ({ ...prev, [field]: file }));
    };

    const handleShopRoleChange = (index, field, value) => {
        const updatedShopRoles = [...shopRolesData];
        updatedShopRoles[index][field] = value;
        setShopRolesData(updatedShopRoles);

        if (errors[`shop_role_${index}`]) {
            setErrors(prev => ({ ...prev, [`shop_role_${index}`]: '' }));
        }
    };

    const removeShopRoleRow = (index) => {
        if (shopRolesData.length <= 1) {
            showToast('warning', translations?.atLeastOneShopRequired || 'User must have at least one shop assignment');
            return;
        }
        setShopRolesData(prev => prev.filter((_, i) => i !== index));
    };

    const addShopRoleRow = () => {
        fetchAllShops();
        setShowShopDropdown(true);
        setShopDropdownRef(document.activeElement);
    };

    // ==============================================
    // SUBSCRIPTION HANDLERS
    // ==============================================
    const handleSubscriptionChange = (field, value) => {
        setSubscriptionData(prev => ({ ...prev, [field]: value }));
    };

    const toggleSubscriptionSection = () => {
        setShowSubscriptionSection(!showSubscriptionSection);
        if (!showSubscriptionSection) {
            setSubscriptionData({
                application_id: applications.length > 0 ? applications[0].id : '',
                plan_type: 'monthly',
                amount: 0,
                start_date: new Date().toISOString().split('T')[0],
                add_subscription: true,
                auto_renew: true,
                grace_period_days: 7
            });
        }
    };

    // ==============================================
    // FETCH ALL SHOPS
    // ==============================================
    const fetchAllShops = async (search = '') => {
        try {
            const params = new URLSearchParams({
                action: 'get_all_shops',
                current_user_id: user?.id || '',
                current_user_role: user?.role || ''
            });
            if (search) params.append('search', search);

            const response = await fetch(`https://ourzestapp.online/oz_backend/root_users.php?${params}`);
            const data = await response.json();

            if (data.success) {
                setAllAvailableShops(data.data);
            }
        } catch (error) {
            console.error('Error fetching shops:', error);
        }
    };

    // Add shop with role
    const addShopWithRole = (shop) => {
        if (!shop) return;

        const assignedShopIds = shopRolesData.map(item => item.shop_id);
        if (assignedShopIds.includes(shop.shop_id)) {
            showToast('warning', 'This shop is already assigned');
            setShowShopDropdown(false);
            setShopSearchTerm('');
            return;
        }

        setShopRolesData(prev => [...prev, {
            shop_id: shop.shop_id,
            shop_name: shop.shop_name,
            shop_code: shop.shop_code,
            role: ''
        }]);

        setShowShopDropdown(false);
        setShopSearchTerm('');
    };

    // Handle shop search
    const handleShopSearchChange = (e) => {
        const value = e.target.value;
        setShopSearchTerm(value);
        fetchAllShops(value);
        setShowShopDropdown(true);
    };

    // ==============================================
    // FILTER AND PAGINATION HANDLERS
    // ==============================================
    const handleFilterChange = (key, value) => {
        setFilters(prev => ({ ...prev, [key]: value }));
        setPagination(prev => ({ ...prev, page: 1 }));
    };

    // ==============================================
    // COMPLETE OPEN MODAL WITH SUBSCRIPTION
    // ==============================================
    const openModal = async (type, userData = null) => {
        setModalType(type);
        setSelectedUser(userData);
        const autoBusinessName = user?.businessname || '';
        const availableShops = await getAvailableShopsForAssignment();
        setAvailableShopsForAssignment(availableShops);
        let initialShopRoles = [];

        // Reset subscription section
        setShowSubscriptionSection(false);
        setSelectedUserSubscriptions([]);
        setSubscriptionData({
            application_id: applications.length > 0 ? applications[0].id : '',
            plan_type: 'monthly',
            amount: 0,
            start_date: new Date().toISOString().split('T')[0],
            add_subscription: false,
            auto_renew: true,
            grace_period_days: 7
        });

        if (type === 'add') {
            let initialShops = [];
            if (isAdmin) {
                const adminShops = await loadAdminAvailableShops();
                initialShops = adminShops.map(shop => ({
                    shop_id: shop.shop_id,
                    shop_name: shop.shop_name,
                    shop_code: shop.shop_code,
                    role: ''
                }));
            }

            setFormData({
                username: '', email: '', password: '', confirmPassword: '', fullname: '', phonenumber: '',
                businessname: isAdmin ? user?.businessname || '' : autoBusinessName || '',
                businessmodule: 'dashboard', businessaddress: isAdmin ? user?.businessaddress || '' : '',
                themecolor: themeColor, language: 'english', status: 'active', two_factor_enabled: 0,
                can_create_shops: 0, shop_id: '', shops: '[]', default_shop_id: '',
                profile_image: null, bussinesslogo: null
            });

            setShopRolesData(initialShops);

        } else if (userData) {
            try {
                const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ action: 'get_user_shop_roles', user_id: userData.id })
                });
                const data = await response.json();
                if (data.success && data.data) {
                    initialShopRoles = data.data.map(item => ({
                        shop_id: item.shop_id, shop_name: item.shop_name, shop_code: item.shop_code,
                        role: item.role, id: item.id
                    }));
                }
            } catch (error) {
                console.error('Error loading shop roles:', error);
            }

            setFormData({
                username: userData.username || '', email: userData.email || '', password: '', confirmPassword: '',
                fullname: userData.fullname || '', phonenumber: userData.phonenumber || '',
                businessname: isAdmin ? user?.businessname || '' : (userData.businessname || autoBusinessName || ''),
                businessmodule: userData.businessmodule || 'dashboard',
                businessaddress: isAdmin ? user?.businessaddress || '' : (userData.businessaddress || ''),
                themecolor: userData.themecolor || themeColor,
                language: userData.language || 'english', status: userData.status || 'active',
                two_factor_enabled: userData.two_factor_enabled || 0, can_create_shops: userData.can_create_shops || 0,
                shop_id: userData.shop_id || '', shops: userData.shops || '[]', default_shop_id: userData.default_shop_id || '',
                profile_image: null, bussinesslogo: null
            });
            setShopRolesData(initialShopRoles);

            // Fetch user subscriptions
            await fetchUserSubscriptions(userData.id);
        }

        setErrors({});
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
        setSelectedUser(null);
        setFormData({
            username: '', email: '', password: '', confirmPassword: '', fullname: '', phonenumber: '',
            businessname: '', businessmodule: 'dashboard', businessaddress: '', themecolor: themeColor,
            language: 'english', status: 'active', two_factor_enabled: 0, can_create_shops: 0,
            shop_id: '', shops: '[]', default_shop_id: '', profile_image: null, bussinesslogo: null
        });
        setShopRolesData([]);
        setShowShopDropdown(false);
        setShopSearchTerm('');
        setShowSubscriptionSection(false);
        setSelectedUserSubscriptions([]);
        setSubscriptionData({
            application_id: '',
            plan_type: 'monthly',
            amount: 0,
            start_date: new Date().toISOString().split('T')[0],
            add_subscription: false,
            auto_renew: true,
            grace_period_days: 7
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        if (shopRolesData.length === 0) {
            showToast('error', translations?.atLeastOneShop || 'At least one shop with role must be assigned');
            return;
        }

        for (const item of shopRolesData) {
            if (!item.shop_id || !item.role) {
                showToast('error', translations?.shopRoleRequired || 'Each shop must have a role selected');
                return;
            }
            if (user?.role?.startsWith('admin_') && item.role.startsWith('admin_')) {
                showToast('error', translations?.userRolesOnly || 'Admin users cannot assign admin roles');
                return;
            }
        }

        setLoading(true);
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('action', modalType === 'add' ? 'create' : 'update');
            formDataToSend.append('created_by', user.id);
            formDataToSend.append('current_user_id', user.id);
            if (modalType === 'edit' && selectedUser) formDataToSend.append('id', selectedUser.id);

            const shopRolesPayload = shopRolesData.map(item => ({
                shop_id: parseInt(item.shop_id),
                role: item.role
            }));
            formDataToSend.append('shop_roles', JSON.stringify(shopRolesPayload));

            const fieldsToSend = ['username', 'email', 'fullname', 'phonenumber', 'businessname',
                'businessmodule', 'businessaddress', 'themecolor', 'language', 'status',
                'two_factor_enabled', 'can_create_shops'];
            if (modalType === 'add') fieldsToSend.push('password');

            fieldsToSend.forEach(field => {
                const value = formData[field];
                if (value !== undefined && value !== null && value !== '') {
                    if (field === 'two_factor_enabled' || field === 'can_create_shops') {
                        formDataToSend.append(field, value ? '1' : '0');
                    } else {
                        formDataToSend.append(field, value.toString());
                    }
                }
            });

            // Add subscription data if enabled
            if (showSubscriptionSection && subscriptionData.add_subscription && isSuperAdmin && selectedUser) {
                const subPayload = {
                    application_id: parseInt(subscriptionData.application_id),
                    plan_type: subscriptionData.plan_type,
                    amount: parseFloat(subscriptionData.amount) || 0,
                    start_date: subscriptionData.start_date
                };
                formDataToSend.append('subscription', JSON.stringify(subPayload));
            }

            if (formData.profile_image instanceof File) formDataToSend.append('profile_image', formData.profile_image);
            if (formData.bussinesslogo instanceof File) formDataToSend.append('bussinesslogo', formData.bussinesslogo);

            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php', { method: 'POST', body: formDataToSend });
            const data = await response.json();

            if (data.success) {
                let successMessage = modalType === 'add' ? (translations?.userCreated || 'User created successfully!') : (translations?.userUpdated || 'User updated successfully!');
                if (data.shop_roles && data.shop_roles.length > 0) successMessage += ` with ${data.shop_roles.length} shop role(s)`;
                if (showSubscriptionSection && subscriptionData.add_subscription) {
                    successMessage += ' and subscription assigned';
                }
                showToast('success', successMessage);
                closeModal();
                loadUsers();
            } else {
                throw new Error(data.error || 'Failed to save user');
            }
        } catch (error) {
            console.error('Submission error:', error);
            showToast('error', error.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async () => {
        if (!selectedUser) return;
        setLoading(true);
        try {
            const formDataToSend = new FormData();
            formDataToSend.append('action', 'delete');
            formDataToSend.append('id', selectedUser.id);
            formDataToSend.append('current_user_id', user.id);
            const response = await fetch('https://ourzestapp.online/oz_backend/root_users.php', { method: 'POST', body: formDataToSend });
            const data = await response.json();
            if (data.success) {
                showToast('success', translations?.userDeleted || 'User deleted successfully!');
                closeModal();
                loadUsers();
            } else {
                throw new Error(data.error || 'Failed to delete user');
            }
        } catch (error) {
            showToast('error', error.message);
        } finally {
            setLoading(false);
        }
    };

    // ==============================================
    // RENDER HELPERS
    // ==============================================
    const renderUserAvatar = (userData) => {
        if (userData.profile_image) {
            return <img src={`https://ourzestapp.online/oz_backend/uploads/profiles/${userData.profile_image}`} alt={userData.fullname} className="root-users-user-avatar" />;
        }
        return <div className="root-users-avatar-placeholder">{userData.fullname?.charAt(0).toUpperCase() || 'U'}</div>;
    };

    const renderStatusBadge = (status) => {
        let statusText = status === 'active' ? (translations?.active || 'Active') : status === 'inactive' ? (translations?.inactive || 'Inactive') : (translations?.suspended || 'Suspended');
        return <span className={`root-users-status-badge root-users-status-${status}`}>{statusText}</span>;
    };

    const renderRoleBadge = (role) => {
        if (!role) return <span className="root-users-role-badge root-users-role-user">No Role</span>;
        const roleText = role.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        let roleClass = 'root-users-role-user';
        if (role === 'super_admin') roleClass = 'root-users-role-super-admin';
        else if (str_starts_with(role, 'admin_')) roleClass = 'root-users-role-admin';
        else if (str_starts_with(role, 'manager_')) roleClass = 'root-users-role-manager';
        else if (str_starts_with(role, 'user_')) roleClass = 'root-users-role-user';
        else if (str_starts_with(role, 'viewer_')) roleClass = 'root-users-role-viewer';
        return <span className={`root-users-role-badge ${roleClass}`}>{roleText}</span>;
    };

    const renderShopsInfo = (userData) => {
        if (!userData.shop_roles || userData.shop_roles.length === 0) {
            return <span className="root-users-no-shop">{translations?.noShopRoles || 'No shop roles assigned'}</span>;
        }
        return (
            <div className="root-users-shops-info">
                {userData.shop_roles.slice(0, 3).map((shopRole, index) => (
                    <div key={`shop-${shopRole.shop_id}-${index}`} className="root-users-shop-tag">
                        <FontAwesomeIcon icon={faShop} />
                        <span>{shopRole.shop_name || `Shop #${shopRole.shop_id}`}</span>
                    </div>
                ))}
                {userData.shop_roles.length > 3 && <span className="root-users-more-shops">+{userData.shop_roles.length - 3} {translations?.more || 'more'}</span>}
            </div>
        );
    };

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showShopDropdown && shopDropdownRef && !shopDropdownRef.contains(event.target)) {
                setShowShopDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showShopDropdown, shopDropdownRef]);

    // ==============================================
    // DARK MODE AUTO-SYNC
    // ==============================================
    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);
            const container = document.querySelector('.root-users-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('root-users-dark');
                } else {
                    container.classList.remove('root-users-dark');
                }
            }
            if (isDarkMode) {
                document.body.classList.add('root-users-dark-body');
            } else {
                document.body.classList.remove('root-users-dark-body');
            }
        };

        syncDarkMode();

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') syncDarkMode();
        };

        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                const container = document.querySelector('.root-users-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('root-users-dark');
                    } else {
                        container.classList.remove('root-users-dark');
                    }
                }
                if (isDark) {
                    document.body.classList.add('root-users-dark-body');
                } else {
                    document.body.classList.remove('root-users-dark-body');
                }
            } else {
                syncDarkMode();
            }
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);

        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) syncDarkMode();
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // ==============================================
    // THEME COLOR AUTO-SYNC
    // ==============================================
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) color = '#4F46E5';
        document.documentElement.style.setProperty('--root-users-primary', color);
        document.documentElement.style.setProperty('--root-users-primary-dark', color);
        document.documentElement.style.setProperty('--root-users-primary-light', color);
        setThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#4F46E5';
        applyTheme(savedTheme);

        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') applyTheme(e.newValue || '#4F46E5');
        };

        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) applyTheme(event.detail.theme);
        };

        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);

        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== themeColor) applyTheme(storedTheme);
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [applyTheme, themeColor]);

    // ==============================================
    // LANGUAGE AUTO-SYNC
    // ==============================================
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await rootUsersTranslator.getTranslations(lang);
            setTranslations(trans);
        };

        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };

        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };

        loadTranslations(currentLanguage);

        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);

        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);

        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // ==============================================
    // RTL DIRECTION SYNC
    // ==============================================
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.root-users-container');
        if (container) {
            if (isRTL) {
                container.classList.add('root-users-rtl');
            } else {
                container.classList.remove('root-users-rtl');
            }
        }
        document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
        document.body.dir = isRTL ? 'rtl' : 'ltr';
    }, [currentLanguage]);

    // ==============================================
    // TOAST TIMER CLEANUP
    // ==============================================
    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearInterval(toastTimerRef.current);
        };
    }, []);

    // ==============================================
    // TRANSLATION FUNCTIONS
    // ==============================================
    const loadTranslations = useCallback(async (lang) => {
        if (!lang) return;
        setIsTranslating(true);
        try {
            const trans = await rootUsersTranslator.getTranslations(lang);
            setTranslations(trans);
            const isRTL = lang === 'ur' || lang === 'ar';
            document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
            document.body.dir = isRTL ? 'rtl' : 'ltr';
        } catch (error) {
            console.error('Error loading translations:', error);
        } finally {
            setIsTranslating(false);
        }
    }, []);

    useEffect(() => {
        loadTranslations(currentLanguage);
        const handleLanguageChange = () => {
            const newLang = localStorage.getItem('ourzest_language') || 'en';
            if (newLang !== currentLanguage) {
                setCurrentLanguage(newLang);
                loadTranslations(newLang);
            }
        };
        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };
        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);
        const intervalId = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 500);
        const translationListener = (lang) => {
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };
        rootUsersTranslator.addListener(translationListener);
        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(intervalId);
            rootUsersTranslator.removeListener(translationListener);
        };
    }, [currentLanguage, loadTranslations]);

    // ==============================================
    // APPLY THEME
    // ==============================================
    useEffect(() => {
        const applyTheme = (color) => {
            try {
                if (!/^#[0-9A-F]{6}$/i.test(color)) color = '#4F46E5';
                const hex = color.replace('#', '');
                const r = parseInt(hex.substring(0, 2), 16);
                const g = parseInt(hex.substring(2, 4), 16);
                const b = parseInt(hex.substring(4, 6), 16);
                const adjust = (amount) => {
                    let newR = Math.max(0, Math.min(255, r + amount));
                    let newG = Math.max(0, Math.min(255, g + amount));
                    let newB = Math.max(0, Math.min(255, b + amount));
                    return `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;
                };
                const palette = {
                    'root-users-primary': color,
                    'root-users-primary-dark': adjust(-40),
                    'root-users-primary-light': adjust(40),
                    'root-users-primary-ultralight': adjust(20),
                    'root-users-primary-gradient': `linear-gradient(135deg, ${color}, ${adjust(-20)})`,
                    'root-users-primary-shadow': `${color}20`
                };
                Object.entries(palette).forEach(([key, value]) => {
                    document.documentElement.style.setProperty(`--${key}`, value);
                });
            } catch (err) {
                console.error("Error applying theme:", err);
            }
        };
        applyTheme(themeColor);
        const handleThemeChange = () => {
            const theme = localStorage.getItem('ourzest_theme') || '#4F46E5';
            if (theme !== themeColor) {
                setThemeColor(theme);
                applyTheme(theme);
            }
        };
        const handleCustomThemeChange = (event) => {
            if (event.detail && event.detail.theme) {
                const theme = event.detail.theme;
                setThemeColor(theme);
                applyTheme(theme);
            }
        };
        handleThemeChange();
        window.addEventListener('storage', handleThemeChange);
        window.addEventListener('themeChanged', handleCustomThemeChange);
        const interval = setInterval(handleThemeChange, 1000);
        return () => {
            window.removeEventListener('storage', handleThemeChange);
            window.removeEventListener('themeChanged', handleCustomThemeChange);
            clearInterval(interval);
        };
    }, [themeColor]);

    // ==============================================
    // INITIAL DATA LOAD
    // ==============================================
    useEffect(() => {
        loadUsers();
        loadAllShops();
        loadAllRoles();
        fetchApplications();
        if (isSuperAdmin) {
            fetchSubscriptionStats();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // ==============================================
    // MAIN RENDER
    // ==============================================
    return (
        <div className={`root-users-container ${isRTL ? 'root-users-rtl' : ''} ${darkMode ? 'root-users-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} darkMode={darkMode} />

            {/* Sticky Header */}
            <div className="root-users-sticky-header">
                <div className="root-users-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="root-users-header-content">
                    <div className="root-users-header-left">
                        <div className="root-users-header-icon">
                            <FontAwesomeIcon icon={showHistoryView ? faHistory : faUsers} />
                        </div>
                        <div className="root-users-header-text">
                            <h1>{showHistoryView ? (translations?.loginHistory || 'Login History') : (translations?.rootUsers || 'Root Users Management')}</h1>
                            <p>{showHistoryView ? 'View and manage all user login activities' : (translations?.manageUsers || 'Manage all system users and their permissions')}</p>
                        </div>
                    </div>
                    <div className="root-users-header-right">
                        {isSuperAdmin && (
                            <>
                                <button
                                    className={`root-users-btn ${showSubscriptionStats ? 'root-users-btn-primary' : 'root-users-btn-secondary'}`}
                                    onClick={() => {
                                        setShowSubscriptionStats(!showSubscriptionStats);
                                        if (!showSubscriptionStats) fetchSubscriptionStats();
                                    }}
                                    disabled={statsLoading}
                                >
                                    <FontAwesomeIcon icon={faChartBar} spin={statsLoading} />
                                    <span>Stats</span>
                                </button>
                                <button
                                    className={`root-users-btn ${showHistoryView ? 'root-users-btn-primary' : 'root-users-btn-secondary'}`}
                                    onClick={toggleHistoryView}
                                    disabled={loading || loadingAllHistory}
                                >
                                    <FontAwesomeIcon icon={faHistory} />
                                    <span>{showHistoryView ? (translations?.users || 'Users') : (translations?.loginHistory || 'Login History')}</span>
                                </button>
                            </>
                        )}
                        <button className="root-users-btn root-users-btn-secondary" onClick={showHistoryView ? toggleHistoryView : loadUsers} disabled={loading || loadingAllHistory}>
                            <FontAwesomeIcon icon={showHistoryView ? faUndo : faSync} spin={loading || loadingAllHistory} />
                            <span>{showHistoryView ? (translations?.backToUsers || 'Back to Users') : (translations?.refresh || 'Refresh')}</span>
                        </button>
                        {!showHistoryView && (
                            <button className="root-users-btn root-users-btn-primary" onClick={() => openModal('add')} disabled={loading}>
                                <FontAwesomeIcon icon={faUserPlus} /> <span>{translations?.addNewUser || 'Add User'}</span>
                            </button>
                        )}
                    </div>
                </div>
            </div>

            {/* Subscription Stats Dashboard */}
            {renderSubscriptionStats()}

            {/* Main Content */}
            {!showHistoryView ? (
                <>
                    {/* Controls */}
                    <div className="root-users-controls">
                        <div className="root-users-controls-left">
                            <div className="root-users-search-box">
                                <FontAwesomeIcon icon={faSearch} />
                                <input type="text" placeholder={translations?.searchPlaceholder || 'Search users...'} value={filters.search} onChange={(e) => handleFilterChange('search', e.target.value)} />
                            </div>
                            <div className="root-users-filter-group">
                                <label><FontAwesomeIcon icon={faFilter} /> {translations?.filterByStatus || 'Status'}</label>
                                <select value={filters.status} onChange={(e) => handleFilterChange('status', e.target.value)}>
                                    <option value="">{translations?.allStatus || 'All'}</option>
                                    <option value="active">{translations?.active || 'Active'}</option>
                                    <option value="inactive">{translations?.inactive || 'Inactive'}</option>
                                    <option value="suspended">{translations?.suspended || 'Suspended'}</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Users Table */}
                    <div className="root-users-table-container">
                        <div className="root-users-table-wrapper">
                            <table className="root-users-table">
                                <thead>
                                    <tr>
                                        <th>{translations?.id || 'ID'}</th>
                                        <th>{translations?.user || 'User'}</th>
                                        <th>{translations?.name || 'Name'}</th>
                                        <th>{translations?.phone || 'Phone'}</th>
                                        <th>{translations?.business || 'Business'}</th>
                                        <th>{translations?.status || 'Status'}</th>
                                        <th>{translations?.subscription || 'Subscription'}</th>
                                        <th>{translations?.primaryRole || 'Role'}</th>
                                        <th>{translations?.shopRoles || 'Shops'}</th>
                                        <th>{translations?.lastLogin || 'Last Login'}</th>
                                        <th>{translations?.actions || 'Actions'}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr><td colSpan="11" className="root-users-table-loading"><div className="root-users-loading-spinner"></div><span>{translations?.loading || 'Loading...'}</span></td></tr>
                                    ) : users.length === 0 ? (
                                        <tr><td colSpan="11" className="root-users-table-empty"><FontAwesomeIcon icon={faUsers} /><span>{translations?.noUsersFound || 'No users found'}</span></td></tr>
                                    ) : (
                                        users.map(userItem => {
                                            const canEdit = canEditUser(userItem);
                                            const canChangePwd = canChangePassword(userItem);
                                            const canDelete = canDeleteUser(userItem);
                                            const isAdminUser = userItem.is_admin_user || false;
                                            const isInherited = userItem.subscription_inherited || false;

                                            return (
                                                <tr key={`user-${userItem.id}`}>
                                                    <td data-label={translations?.id || 'ID'}>{userItem.id}</td>
                                                    <td data-label={translations?.user || 'User'}>
                                                        <div className="root-users-user-cell">
                                                            {renderUserAvatar(userItem)}
                                                            <div className="root-users-user-info">
                                                                <strong>{userItem.username}</strong>
                                                                <small>{userItem.email}</small>
                                                                {isAdminUser && (
                                                                    <span className="admin-badge"><FontAwesomeIcon icon={faCrown} /> Admin</span>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td data-label={translations?.name || 'Name'}>{userItem.fullname}</td>
                                                    <td data-label={translations?.phone || 'Phone'}>{userItem.phonenumber || '-'}</td>
                                                    <td data-label={translations?.business || 'Business'}>{userItem.businessname || '-'}</td>
                                                    <td data-label={translations?.status || 'Status'}>{renderStatusBadge(userItem.status)}</td>
                                                    <td data-label={translations?.subscription || 'Subscription'}>
                                                        <div className="subscription-cell">
                                                            {renderSubscriptionStatus(userItem)}
                                                            {isInherited && (
                                                                <span className="inherited-badge-small" title={`${translations?.inheritedFrom || 'Inherited from'}: ${userItem.subscription_inherited_from || 'Admin'}`}>
                                                                    <FontAwesomeIcon icon={faShare} />
                                                                </span>
                                                            )}
                                                            {userItem.subscriptions && userItem.subscriptions.length > 0 && (
                                                                <span className="sub-count-badge">{userItem.subscriptions.length}</span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td data-label={translations?.primaryRole || 'Role'}>{renderRoleBadge(userItem.role)}</td>
                                                    <td data-label={translations?.shopRoles || 'Shops'}>{renderShopsInfo(userItem)}</td>
                                                    <td data-label={translations?.lastLogin || 'Last Login'}>
                                                        {userItem.last_login ? new Date(userItem.last_login).toLocaleDateString() : 'Never'}
                                                    </td>
                                                    <td data-label={translations?.actions || 'Actions'}>
                                                        <div className="root-users-action-buttons">
                                                            {canEdit && (
                                                                <button className="root-users-action-btn root-users-action-edit" onClick={() => openModal('edit', userItem)}>
                                                                    <FontAwesomeIcon icon={faEdit} />
                                                                </button>
                                                            )}
                                                            {canChangePwd && (
                                                                <button className="root-users-action-btn root-users-action-password" onClick={() => openPasswordModal(userItem)}>
                                                                    <FontAwesomeIcon icon={faKey} />
                                                                </button>
                                                            )}
                                                            {canDelete && (
                                                                <button className="root-users-action-btn root-users-action-delete" onClick={() => openModal('delete', userItem)}>
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {pagination.pages > 1 && (
                            <div className="root-users-pagination">
                                <button className="root-users-page-btn" onClick={() => setPagination(prev => ({ ...prev, page: prev.page - 1 }))} disabled={pagination.page <= 1 || loading}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                <span className="root-users-page-info">{translations?.page || 'Page'} {pagination.page} {translations?.of || 'of'} {pagination.pages}</span>
                                <button className="root-users-page-btn" onClick={() => setPagination(prev => ({ ...prev, page: prev.page + 1 }))} disabled={pagination.page >= pagination.pages || loading}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        )}
                    </div>
                </>
            ) : (
                // Login History View
                <>
                    <div className="root-users-controls">
                        <div className="root-users-controls-left">
                            <div className="root-users-search-box">
                                <FontAwesomeIcon icon={faSearch} />
                                <input type="text" placeholder="Search by user, IP, browser..." value={historyFilters.search} onChange={(e) => handleHistoryFilterChange('search', e.target.value)} />
                            </div>
                            <div className="root-users-filter-group">
                                <label><FontAwesomeIcon icon={faCalendar} /> {translations?.dateFrom || 'Date From'}</label>
                                <input type="date" value={historyFilters.dateFrom} onChange={(e) => handleHistoryFilterChange('dateFrom', e.target.value)} className="root-users-date-input" />
                            </div>
                            <div className="root-users-filter-group">
                                <label><FontAwesomeIcon icon={faCalendar} /> {translations?.dateTo || 'Date To'}</label>
                                <input type="date" value={historyFilters.dateTo} onChange={(e) => handleHistoryFilterChange('dateTo', e.target.value)} className="root-users-date-input" />
                            </div>
                        </div>
                        <div className="root-users-controls-right">
                            <button className="root-users-btn root-users-btn-secondary" onClick={clearHistoryFilters}>
                                <FontAwesomeIcon icon={faTimes} /> {translations?.clearFilters || 'Clear Filters'}
                            </button>
                            <button className="root-users-btn root-users-btn-secondary" onClick={exportToCSV} disabled={exporting || filteredHistory.length === 0}>
                                <FontAwesomeIcon icon={faFileExcel} /> {translations?.exportCSV || 'CSV'}
                            </button>
                            <button className="root-users-btn root-users-btn-secondary" onClick={exportToPDF} disabled={exporting || filteredHistory.length === 0}>
                                <FontAwesomeIcon icon={faFilePdf} /> {translations?.exportPDF || 'PDF'}
                            </button>
                        </div>
                    </div>

                    <div className="root-users-advanced-filters">
                        <div className="root-users-filter-group">
                            <label><FontAwesomeIcon icon={faMobileAlt} /> {translations?.device || 'Device'}</label>
                            <select value={historyFilters.deviceType} onChange={(e) => handleHistoryFilterChange('deviceType', e.target.value)}>
                                <option value="">{translations?.allDevices || 'All Devices'}</option>
                                {deviceTypes.map(device => <option key={device} value={device}>{device.charAt(0).toUpperCase() + device.slice(1)}</option>)}
                            </select>
                        </div>
                        <div className="root-users-filter-group">
                            <label><FontAwesomeIcon icon={faGlobe} /> {translations?.browser || 'Browser'}</label>
                            <select value={historyFilters.browser} onChange={(e) => handleHistoryFilterChange('browser', e.target.value)}>
                                <option value="">{translations?.allBrowsers || 'All Browsers'}</option>
                                {getUniqueBrowsers().map(browser => <option key={browser} value={browser}>{browser}</option>)}
                            </select>
                        </div>
                        <div className="root-users-filter-group">
                            <label><FontAwesomeIcon icon={faLaptopCode} /> {translations?.os || 'OS'}</label>
                            <select value={historyFilters.os} onChange={(e) => handleHistoryFilterChange('os', e.target.value)}>
                                <option value="">{translations?.allOS || 'All OS'}</option>
                                {getUniqueOS().map(os => <option key={os} value={os}>{os}</option>)}
                            </select>
                        </div>
                        <div className="root-users-filter-group">
                            <label><FontAwesomeIcon icon={faCheckCircle} /> {translations?.status || 'Status'}</label>
                            <select value={historyFilters.status} onChange={(e) => handleHistoryFilterChange('status', e.target.value)}>
                                <option value="">{translations?.allStatus || 'All Status'}</option>
                                {statusOptions.map(status => <option key={status} value={status}>{status === 'success' ? 'Success' : 'Failed'}</option>)}
                            </select>
                        </div>
                        <div className="root-users-filter-group">
                            <label><FontAwesomeIcon icon={faNetworkWired} /> {translations?.ipAddress || 'IP Address'}</label>
                            <input type="text" placeholder="Filter by IP..." value={historyFilters.ipAddress} onChange={(e) => handleHistoryFilterChange('ipAddress', e.target.value)} className="root-users-ip-input" />
                        </div>
                    </div>

                    <div className="root-users-history-stats">
                        <div className="root-users-stat-card">
                            <div className="root-users-stat-icon root-users-stat-icon-primary"><FontAwesomeIcon icon={faHistory} /></div>
                            <div className="root-users-stat-info"><h3>{filteredHistory.length}</h3><p>{translations?.totalRecords || 'Total Records'}</p></div>
                        </div>
                        <div className="root-users-stat-card">
                            <div className="root-users-stat-icon root-users-stat-icon-success"><FontAwesomeIcon icon={faCheckCircle} /></div>
                            <div className="root-users-stat-info"><h3>{filteredHistory.filter(r => r.login_status === 'success').length}</h3><p>{translations?.successfulLogins || 'Successful Logins'}</p></div>
                        </div>
                        <div className="root-users-stat-card">
                            <div className="root-users-stat-icon root-users-stat-icon-error"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                            <div className="root-users-stat-info"><h3>{filteredHistory.filter(r => r.login_status === 'failed').length}</h3><p>{translations?.failedAttempts || 'Failed Attempts'}</p></div>
                        </div>
                        <div className="root-users-stat-card">
                            <div className="root-users-stat-icon root-users-stat-icon-info"><FontAwesomeIcon icon={faUsers} /></div>
                            <div className="root-users-stat-info"><h3>{new Set(filteredHistory.map(r => r.user_id)).size}</h3><p>{translations?.uniqueUsers || 'Unique Users'}</p></div>
                        </div>
                    </div>

                    <div className="root-users-table-container">
                        <div className="root-users-table-wrapper">
                            <table className="root-users-table">
                                <thead>
                                    <tr><th>{translations?.user || 'User'}</th><th>Full Name</th><th>{translations?.dateTime || 'Date & Time'}</th><th>{translations?.ipAddress || 'IP Address'}</th><th>{translations?.device || 'Device'}</th><th>{translations?.browser || 'Browser'}</th><th>{translations?.os || 'OS'}</th><th>{translations?.status || 'Status'}</th><th>{translations?.duration || 'Duration'}</th></tr>
                                </thead>
                                <tbody>
                                    {loadingAllHistory ? (
                                        <tr><td colSpan="9" className="root-users-table-loading"><div className="root-users-loading-spinner"></div><span>Loading login history...</span></td></tr>
                                    ) : filteredHistory.length === 0 ? (
                                        <tr><td colSpan="9" className="root-users-table-empty"><FontAwesomeIcon icon={faHistory} /><span>No login history found</span></td></tr>
                                    ) : (
                                        getPaginatedHistory().map((record, index) => (
                                            <tr key={record.id || index}>
                                                <td data-label="User"><div className="root-users-user-cell"><div className="root-users-user-info"><strong>{record.username || 'N/A'}</strong><small>ID: {record.user_id}</small></div></div></td>
                                                <td data-label="Full Name">{record.fullname || 'N/A'}</td>
                                                <td data-label="Date & Time"><div className="login-time"><strong>{new Date(record.login_time).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</strong><small>{new Date(record.login_time).toLocaleDateString()}</small></div></td>
                                                <td data-label="IP Address"><code className="ip-address">{record.ip_address}</code></td>
                                                <td data-label="Device"><div className="device-info"><FontAwesomeIcon icon={record.device_type === 'mobile' ? faMobileAlt : (record.device_type === 'tablet' ? faTabletAlt : faLaptop)} /><span>{record.device_type || 'Desktop'}</span></div></td>
                                                <td data-label="Browser"><div className="browser-info"><span>{record.browser_name || 'Unknown'}</span>{record.browser_version && <small>v{record.browser_version}</small>}</div></td>
                                                <td data-label="OS"><div className="os-info"><span>{record.os_name || 'Unknown'}</span>{record.os_version && <small>{record.os_version}</small>}</div></td>
                                                <td data-label="Status"><span className={`login-status-badge login-status-${record.login_status}`}>{record.login_status === 'success' ? '✓ Success' : '✗ Failed'}</span></td>
                                                <td data-label="Duration"><span className="session-duration">{record.session_duration || 'Active'}</span></td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {historyPagination.pages > 1 && (
                            <div className="root-users-pagination">
                                <button className="root-users-page-btn" onClick={() => setHistoryPagination(prev => ({ ...prev, page: prev.page - 1 }))} disabled={historyPagination.page <= 1 || loadingAllHistory}>
                                    <FontAwesomeIcon icon={faChevronLeft} />
                                </button>
                                <span className="root-users-page-info">Page {historyPagination.page} of {historyPagination.pages}</span>
                                <button className="root-users-page-btn" onClick={() => setHistoryPagination(prev => ({ ...prev, page: prev.page + 1 }))} disabled={historyPagination.page >= historyPagination.pages || loadingAllHistory}>
                                    <FontAwesomeIcon icon={faChevronRight} />
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}

            {/* Add/Edit/Delete Modal */}
            {modalOpen && (
                <div className="root-users-modal-overlay" onClick={closeModal}>
                    <div className="root-users-modal" onClick={e => e.stopPropagation()}>
                        <div className="root-users-modal-header">
                            <h2>
                                <FontAwesomeIcon icon={modalType === 'add' ? faUserPlus : (modalType === 'edit' ? faEdit : faExclamationTriangle)} />
                                {modalType === 'add' ? (translations?.addNewUser || 'Add User') :
                                    modalType === 'edit' ? (translations?.editUser || 'Edit User') :
                                        (translations?.confirmDelete || 'Delete User')}
                            </h2>
                            <button className="root-users-modal-close" onClick={closeModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="root-users-modal-body">
                            {modalType === 'delete' ? (
                                <div className="root-users-delete-confirm">
                                    <div className="root-users-delete-icon"><FontAwesomeIcon icon={faExclamationTriangle} /></div>
                                    <h3>{translations?.deleteConfirmMessage || 'Are you sure?'}</h3>
                                    <p>{translations?.deleteWarning || 'This action cannot be undone.'}</p>
                                    <div className="root-users-modal-footer">
                                        <button className="root-users-btn root-users-btn-secondary" onClick={closeModal}><FontAwesomeIcon icon={faTimes} /> {translations?.cancel || 'Cancel'}</button>
                                        <button className="root-users-btn root-users-btn-danger" onClick={handleDelete} disabled={loading}>
                                            {loading ? <><div className="root-users-loading-spinner" style={{ width: '16px', height: '16px', margin: 0 }}></div>{translations?.deleting || 'Deleting...'}</> : <><FontAwesomeIcon icon={faTrash} /> {translations?.delete || 'Delete'}</>}
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                <form onSubmit={handleSubmit}>
                                    <div className="root-users-form-grid">
                                        {/* User Form Fields */}
                                        <div className={`root-users-form-group ${errors.username ? 'has-error' : ''}`}>
                                            <label className="root-users-form-label">{translations?.username || 'Username'} <span className="required">*</span></label>
                                            <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faUser} className="root-users-input-icon" /><input type="text" name="username" value={formData.username} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                            {errors.username && <div className="root-users-error-message">{errors.username}</div>}
                                        </div>
                                        <div className={`root-users-form-group ${errors.email ? 'has-error' : ''}`}>
                                            <label className="root-users-form-label">{translations?.email || 'Email'} <span className="required">*</span></label>
                                            <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faEnvelope} className="root-users-input-icon" /><input type="email" name="email" value={formData.email} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                            {errors.email && <div className="root-users-error-message">{errors.email}</div>}
                                        </div>
                                        {modalType === 'add' && (
                                            <>
                                                <div className={`root-users-form-group ${errors.password ? 'has-error' : ''}`}>
                                                    <label className="root-users-form-label">{translations?.password || 'Password'} <span className="required">*</span></label>
                                                    <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faLock} className="root-users-input-icon" /><input type="password" name="password" value={formData.password} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                                    {errors.password && <div className="root-users-error-message">{errors.password}</div>}
                                                </div>
                                                <div className={`root-users-form-group ${errors.confirmPassword ? 'has-error' : ''}`}>
                                                    <label className="root-users-form-label">{translations?.confirmPassword || 'Confirm Password'} <span className="required">*</span></label>
                                                    <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faLock} className="root-users-input-icon" /><input type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                                    {errors.confirmPassword && <div className="root-users-error-message">{errors.confirmPassword}</div>}
                                                </div>
                                            </>
                                        )}
                                        <div className={`root-users-form-group ${errors.fullname ? 'has-error' : ''}`}>
                                            <label className="root-users-form-label">{translations?.fullName || 'Full Name'} <span className="required">*</span></label>
                                            <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faIdCard} className="root-users-input-icon" /><input type="text" name="fullname" value={formData.fullname} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                            {errors.fullname && <div className="root-users-error-message">{errors.fullname}</div>}
                                        </div>
                                        <div className="root-users-form-group">
                                            <label className="root-users-form-label">{translations?.phoneNumber || 'Phone'}</label>
                                            <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faPhone} className="root-users-input-icon" /><input type="tel" name="phonenumber" value={formData.phonenumber} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                        </div>

                                        {!isAdmin && (
                                            <>
                                                <div className="root-users-form-group">
                                                    <label className="root-users-form-label">{translations?.businessName || 'Business Name'}</label>
                                                    <div className="root-users-input-wrapper"><FontAwesomeIcon icon={faStore} className="root-users-input-icon" /><input type="text" name="businessname" value={formData.businessname} onChange={handleFormChange} className="root-users-input" disabled={loading} /></div>
                                                </div>

                                                <div className="root-users-form-group">
                                                    <label className="root-users-form-label">{translations?.businessLogo || 'Business Logo'}</label>
                                                    <div className="root-users-file-upload">
                                                        <input type="file" ref={logoInputRef} onChange={(e) => handleFileChange(e, 'bussinesslogo')} accept="image/*" className="root-users-file-input" disabled={loading} />
                                                        {formData.bussinesslogo && typeof formData.bussinesslogo === 'string' && (
                                                            <div className="root-users-logo-preview">
                                                                <img src={`https://ourzestapp.online/oz_backend/uploads/logos/${formData.bussinesslogo}`} alt="Business Logo" className="root-users-logo-preview-img" />
                                                                <button type="button" className="root-users-remove-logo" onClick={() => setFormData(prev => ({ ...prev, bussinesslogo: null }))}><FontAwesomeIcon icon={faTimes} /></button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="root-users-form-group">
                                                    <label className="root-users-form-label">{translations?.profileImage || 'Profile Image'}</label>
                                                    <div className="root-users-file-upload">
                                                        <input type="file" ref={fileInputRef} onChange={(e) => handleFileChange(e, 'profile_image')} accept="image/*" className="root-users-file-input" disabled={loading} />
                                                        {formData.profile_image && typeof formData.profile_image === 'string' && (
                                                            <div className="root-users-logo-preview">
                                                                <img src={`https://ourzestapp.online/oz_backend/uploads/profiles/${formData.profile_image}`} alt="Profile" className="root-users-logo-preview-img" />
                                                                <button type="button" className="root-users-remove-logo" onClick={() => setFormData(prev => ({ ...prev, profile_image: null }))}><FontAwesomeIcon icon={faTimes} /></button>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className="root-users-form-group root-users-form-group-full">
                                                    <label className="root-users-form-label">{translations?.businessAddress || 'Business Address'}</label>
                                                    <textarea name="businessaddress" value={formData.businessaddress} onChange={handleFormChange} className="root-users-textarea" rows="3" disabled={loading} />
                                                </div>
                                            </>
                                        )}

                                        <div className="root-users-form-group">
                                            <label className="root-users-form-label">{translations?.status || 'Status'}</label>
                                            <div className="root-users-input-wrapper"><select name="status" value={formData.status} onChange={handleFormChange} className="root-users-select" disabled={loading}><option value="active">{translations?.active || 'Active'}</option><option value="inactive">{translations?.inactive || 'Inactive'}</option><option value="suspended">{translations?.suspended || 'Suspended'}</option></select></div>
                                        </div>

                                        <div className="root-users-form-group root-users-form-group-full">
                                            <label className="root-users-form-label">{translations?.assignShopRoles || 'Assign Shop Roles'} <span className="required">*</span></label>
                                            <div className="root-users-shop-roles-section">
                                                {shopRolesData.map((item, index) => {
                                                    const availableRoles = getRolesForShop(item.shop_id);
                                                    return (
                                                        <div key={`shop-role-${item.shop_id}-${index}`} className="root-users-shop-role-item">
                                                            <div className="root-users-shop-info"><FontAwesomeIcon icon={faShop} /><div className="root-users-shop-details"><strong>{item.shop_name || `Shop #${item.shop_id}`}</strong><small>{item.shop_code || 'No code'}</small></div></div>
                                                            <div className="root-users-role-select">
                                                                <select
                                                                    value={item.role || ''}
                                                                    onChange={(e) => handleShopRoleChange(index, 'role', e.target.value)}
                                                                    disabled={loading}
                                                                    className={errors[`shop_role_${index}`] ? 'has-error' : ''}
                                                                >
                                                                    <option value="">{translations?.selectRole || 'Select Role'}</option>
                                                                    {availableRoles.map(role => (
                                                                        <option key={`role-${role.value}`} value={role.value}>{role.label}</option>
                                                                    ))}
                                                                </select>
                                                                {errors[`shop_role_${index}`] && (
                                                                    <div className="root-users-error-message">{errors[`shop_role_${index}`]}</div>
                                                                )}
                                                            </div>
                                                            <button type="button" className="root-users-remove-shop" onClick={() => removeShopRoleRow(index)} disabled={loading || shopRolesData.length <= 1}><FontAwesomeIcon icon={faTrash} /></button>
                                                        </div>
                                                    );
                                                })}

                                                <div className="root-users-add-shop-container" ref={node => { if (node) setShopDropdownRef(node); }}>
                                                    <button type="button" className="root-users-btn root-users-btn-secondary root-users-add-shop-btn" onClick={addShopRoleRow} disabled={loading}>
                                                        <FontAwesomeIcon icon={faPlus} /> {translations?.addAnotherShop || 'Add Another Shop'}
                                                    </button>

                                                    {showShopDropdown && (
                                                        <div className="root-users-shop-dropdown">
                                                            <div className="root-users-shop-dropdown-header">
                                                                <FontAwesomeIcon icon={faSearch} className="root-users-shop-search-icon" />
                                                                <input type="text" placeholder="Search shops by name or code..." value={shopSearchTerm} onChange={handleShopSearchChange} className="root-users-shop-search-input" autoFocus />
                                                                <button type="button" className="root-users-shop-dropdown-close" onClick={() => setShowShopDropdown(false)}><FontAwesomeIcon icon={faTimes} /></button>
                                                            </div>
                                                            <div className="root-users-shop-dropdown-list">
                                                                {allAvailableShops.length === 0 ? (
                                                                    <div className="root-users-shop-dropdown-empty">{shopSearchTerm ? 'No shops found' : 'Loading shops...'}</div>
                                                                ) : (
                                                                    allAvailableShops.map(shop => {
                                                                        const isAlreadyAssigned = shopRolesData.some(item => item.shop_id === shop.shop_id);
                                                                        return (
                                                                            <div key={shop.shop_id} className={`root-users-shop-dropdown-item ${isAlreadyAssigned ? 'disabled' : ''}`} onClick={() => !isAlreadyAssigned && addShopWithRole(shop)}>
                                                                                <div className="root-users-shop-dropdown-info"><strong>{shop.shop_name}</strong><small>{shop.shop_code}</small></div>
                                                                                {isAlreadyAssigned && <span className="root-users-shop-assigned-badge">Assigned</span>}
                                                                            </div>
                                                                        );
                                                                    })
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* SUBSCRIPTION SECTION - ONLY FOR SUPER ADMIN */}
                                        {/* SUBSCRIPTION SECTION - FOR SUPER ADMIN AND ADMIN */}
                                       {/* SUBSCRIPTION SECTION - FOR SUPER ADMIN AND ADMIN */}
{(isSuperAdmin) && (
    <div className="root-users-form-group root-users-form-group-full">
        <div className="subscription-section">
            <div className="subscription-toggle">
                <button
                    type="button"
                    className={`subscription-toggle-btn ${showSubscriptionSection ? 'active' : ''}`}
                    onClick={toggleSubscriptionSection}
                >
                    <FontAwesomeIcon icon={faCreditCardIcon} />
                    <span>{showSubscriptionSection ? 'Hide Subscription' : 'Add Subscription'}</span>
                </button>
                {/* ONLY show View Subscriptions button when editing an existing user */}
                {selectedUser && modalType === 'edit' && (
                    <button
                        type="button"
                        className="subscription-view-btn"
                        onClick={() => {
                            if (selectedUser) {
                                fetchUserSubscriptions(selectedUser.id);
                                // Scroll to subscription section
                                setTimeout(() => {
                                    const elem = document.querySelector('.subscription-details-modal');
                                    if (elem) elem.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                }, 100);
                            }
                        }}
                    >
                        <FontAwesomeIcon icon={faEye} /> View Subscriptions
                    </button>
                )}
            </div>

            {/* User's existing subscriptions - ONLY show when editing */}
            {selectedUser && modalType === 'edit' && (
                <div className="user-subscriptions-preview">
                    {renderSubscriptionDetailsModal()}
                </div>
            )}

            {/* Add new subscription form - ONLY for Super Admin and ONLY when showSubscriptionSection is true */}
            {isSuperAdmin && showSubscriptionSection && (
                <div className="subscription-form-section">
                    <div className="subscription-form-header">
                        <h4><FontAwesomeIcon icon={faPlus} /> Add New Subscription</h4>
                        <button
                            className="btn-close"
                            onClick={() => setShowSubscriptionSection(false)}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <div className="subscription-form-grid">
                        <div className="form-group">
                            <label>{translations?.application || 'Application'} <span className="required">*</span></label>
                            <select
                                value={subscriptionData.application_id}
                                onChange={(e) => setSubscriptionData(prev => ({ ...prev, application_id: e.target.value }))}
                                className="form-select"
                            >
                                <option value="">Select Application</option>
                                {applications.map(app => (
                                    <option key={app.id} value={app.id}>
                                        {app.app_name} ({app.app_code})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group">
                            <label>{translations?.planType || 'Plan'} <span className="required">*</span></label>
                            <select
                                value={subscriptionData.plan_type}
                                onChange={(e) => setSubscriptionData(prev => ({ ...prev, plan_type: e.target.value }))}
                                className="form-select"
                            >
                                <option value="monthly">{translations?.monthly || 'Monthly'}</option>
                                <option value="yearly">{translations?.yearly || 'Yearly'}</option>
                                <option value="custom">{translations?.custom || 'Custom'}</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <label>{translations?.amount || 'Amount'} <span className="required">*</span></label>
                            <input
                                type="number"
                                step="0.01"
                                value={subscriptionData.amount}
                                onChange={(e) => setSubscriptionData(prev => ({ ...prev, amount: e.target.value }))}
                                className="form-input"
                                placeholder="0.00"
                            />
                        </div>
                        <div className="form-group">
                            <label>{translations?.startDate || 'Start Date'} <span className="required">*</span></label>
                            <input
                                type="date"
                                value={subscriptionData.start_date}
                                onChange={(e) => setSubscriptionData(prev => ({ ...prev, start_date: e.target.value }))}
                                className="form-input"
                            />
                        </div>
                        <div className="form-group">
                            <label>Grace Period (Days)</label>
                            <input
                                type="number"
                                value={subscriptionData.grace_period_days}
                                onChange={(e) => setSubscriptionData(prev => ({ ...prev, grace_period_days: parseInt(e.target.value) || 7 }))}
                                className="form-input"
                                min="1"
                                max="30"
                            />
                        </div>
                        <div className="form-group checkbox-group">
                            <label className="checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={subscriptionData.auto_renew}
                                    onChange={(e) => setSubscriptionData(prev => ({ ...prev, auto_renew: e.target.checked }))}
                                />
                                Auto Renew
                            </label>
                        </div>
                    </div>
                    <div className="subscription-form-actions">
                        <button
                            className="btn btn-primary"
                            onClick={async () => {
                                if (!subscriptionData.application_id) {
                                    showToast('error', 'Please select an application');
                                    return;
                                }
                                if (!selectedUser) {
                                    showToast('error', 'Please save the user first before adding a subscription');
                                    return;
                                }
                                const result = await createSubscriptionForUser(selectedUser.id, subscriptionData);
                                if (result.success) {
                                    showToast('success', 'Subscription created successfully!');
                                    setShowSubscriptionSection(false);
                                    await fetchUserSubscriptions(selectedUser.id);
                                    loadUsers();
                                } else {
                                    showToast('error', result.error || 'Failed to create subscription');
                                }
                            }}
                        >
                            <FontAwesomeIcon icon={faSave} /> Create Subscription
                        </button>
                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowSubscriptionSection(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    </div>
)}

                                        {user?.role === 'super_admin' && (
                                            <div className="root-users-form-group">
                                                <label className="root-users-checkbox-label"><input type="checkbox" name="can_create_shops" checked={formData.can_create_shops === 1} onChange={handleFormChange} disabled={loading} /><FontAwesomeIcon icon={faStore} /> {translations?.allowCreateShops || 'Allow to create shops'}</label>
                                            </div>
                                        )}
                                    </div>
                                    <div className="root-users-modal-footer">
                                        <button type="button" className="root-users-btn root-users-btn-secondary" onClick={closeModal} disabled={loading}><FontAwesomeIcon icon={faTimes} /> {translations?.cancel || 'Cancel'}</button>
                                        <button type="submit" className="root-users-btn root-users-btn-primary" disabled={loading}>
                                            {loading ? <><div className="root-users-loading-spinner" style={{ width: '16px', height: '16px', margin: 0 }}></div>{modalType === 'add' ? (translations?.saving || 'Saving...') : (translations?.updating || 'Updating...')}</> : <><FontAwesomeIcon icon={faSave} /> {modalType === 'add' ? (translations?.save || 'Save') : (translations?.update || 'Update')}</>}
                                        </button>
                                    </div>
                                </form>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Password Update Modal */}
            {passwordModalOpen && (
                <div className="root-users-modal-overlay" onClick={closePasswordModal}>
                    <div className="root-users-modal" onClick={e => e.stopPropagation()}>
                        <div className="root-users-modal-header">
                            <h2><FontAwesomeIcon icon={faKey} /> {translations?.changePassword || 'Change Password'}</h2>
                            <button className="root-users-modal-close" onClick={closePasswordModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>
                        <div className="root-users-modal-body">
                            <form onSubmit={handlePasswordUpdate}>
                                <p style={{ marginBottom: '1rem', color: 'var(--root-users-text-secondary)' }}>
                                    {translations?.user || 'User'}: <strong>{selectedUser?.fullname || selectedUser?.username || 'User'}</strong>
                                    {selectedUser?.username && ` (${selectedUser.username})`}
                                </p>
                                <div className="root-users-form-grid">
                                    <div className={`root-users-form-group ${passwordErrors.newPassword ? 'has-error' : ''}`}>
                                        <label className="root-users-form-label">{translations?.newPassword || 'New Password'} <span className="required">*</span></label>
                                        <div className="root-users-input-wrapper">
                                            <FontAwesomeIcon icon={faLock} className="root-users-input-icon" />
                                            <input
                                                type="password"
                                                value={passwordFormData.newPassword}
                                                onChange={(e) => setPasswordFormData(prev => ({ ...prev, newPassword: e.target.value }))}
                                                className="root-users-input"
                                                disabled={updatingPassword}
                                                placeholder="Enter new password"
                                            />
                                        </div>
                                        {passwordErrors.newPassword && <div className="root-users-error-message">{passwordErrors.newPassword}</div>}
                                    </div>
                                    <div className={`root-users-form-group ${passwordErrors.confirmPassword ? 'has-error' : ''}`}>
                                        <label className="root-users-form-label">{translations?.confirmPassword || 'Confirm Password'} <span className="required">*</span></label>
                                        <div className="root-users-input-wrapper">
                                            <FontAwesomeIcon icon={faLock} className="root-users-input-icon" />
                                            <input
                                                type="password"
                                                value={passwordFormData.confirmPassword}
                                                onChange={(e) => setPasswordFormData(prev => ({ ...prev, confirmPassword: e.target.value }))}
                                                className="root-users-input"
                                                disabled={updatingPassword}
                                                placeholder="Confirm new password"
                                            />
                                        </div>
                                        {passwordErrors.confirmPassword && <div className="root-users-error-message">{passwordErrors.confirmPassword}</div>}
                                    </div>
                                </div>
                                <div className="root-users-modal-footer">
                                    <button type="button" className="root-users-btn root-users-btn-secondary" onClick={closePasswordModal} disabled={updatingPassword}>
                                        <FontAwesomeIcon icon={faTimes} /> {translations?.cancel || 'Cancel'}
                                    </button>
                                    <button type="submit" className="root-users-btn root-users-btn-primary" disabled={updatingPassword}>
                                        {updatingPassword ? (
                                            <><div className="root-users-loading-spinner" style={{ width: '16px', height: '16px', margin: 0 }}></div> {translations?.updating || 'Updating...'}</>
                                        ) : (
                                            <><FontAwesomeIcon icon={faSave} /> {translations?.updatePassword || 'Update Password'}</>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            {/* Loading Overlay */}
            {loading && (
                <div className="root-users-loading-overlay">
                    <div className="root-users-loading-content">
                        <div className="root-users-loading-spinner"></div>
                        <p className="root-users-loading-text">{translations?.loading || 'Loading...'}</p>
                        <p className="root-users-loading-subtext">{translations?.loadingData || 'Please wait...'}</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default RootUsers;